webpackJsonp([1],Array(18).concat([
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(80);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);





var state = {
  me: {},
  vacations: {},
  holidays: {},
  newVacations: [],
  newHolidays: [],
  startDate: '',
  endDate: '',
  selectDay: [],
  selectedYear: new Date().getFullYear(),
  bookedDays: 0,
  showMore: '',
  editingId: '',
  updateVacations: false,
  updateHolidays: false,
  apiError: undefined,
  availableDays: 27,
  kaleiders: [],
  importVacationsSuccess: false,
  holidayName: ''
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__
}));

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_Home_Home__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_Home_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__layout_Home_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_Login_Login__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_Login_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__layout_Login_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_LoginKo_LoginKo__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_LoginKo_LoginKo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__layout_LoginKo_LoginKo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_Admin_Admin__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_Admin_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__layout_Admin_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_NotFound_NotFound__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_NotFound_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__layout_NotFound_NotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PublicHolidays_PublicHolidays__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PublicHolidays_PublicHolidays___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_PublicHolidays_PublicHolidays__);












__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var ROUTER = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_4__layout_Login_Login___default.a
  }, {
    path: '/login-ko',
    name: 'LoginKo',
    component: __WEBPACK_IMPORTED_MODULE_5__layout_LoginKo_LoginKo___default.a
  }, {
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_3__layout_Home_Home___default.a,
    isDefault: true,
    meta: { requireAuth: true }
  }, {
    path: '/admin',
    component: __WEBPACK_IMPORTED_MODULE_6__layout_Admin_Admin___default.a,
    redirect: { name: 'publicHolidays' },
    meta: {
      requireAuth: true,
      requireAdmin: true
    },
    children: [{
      path: 'public-holidays',
      name: 'publicHolidays',
      component: __WEBPACK_IMPORTED_MODULE_8__components_PublicHolidays_PublicHolidays___default.a
    }]
  }, {
    path: '/not-found',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_7__layout_NotFound_NotFound___default.a
  }, {
    path: '*',
    redirect: { name: '404' }
  }]
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hooks__["a" /* default */])(ROUTER);

/* harmony default export */ __webpack_exports__["a"] = (ROUTER);

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(139)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(185),
  /* scopeId */
  "data-v-698891db",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(143)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(189),
  /* scopeId */
  "data-v-8f629efa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(142)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(188),
  /* scopeId */
  "data-v-8c76a24a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(138)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(184),
  /* scopeId */
  "data-v-5affc9fd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(140)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(186),
  /* scopeId */
  "data-v-715ed6fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(134)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(180),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports) {

var shortMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var defMonthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

var dateFunc = {
  getDuration: function getDuration(date) {
    var dt = new Date(date);

    dt.setMonth(dt.getMonth() + 1);
    dt.setDate(0);
    return dt.getDate();
  },
  changeDay: function changeDay(date, num) {
    var dt = new Date(date);
    return new Date(dt.setDate(dt.getDate() + num));
  },
  getStartDate: function getStartDate(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  },
  getEndDate: function getEndDate(date) {
    var dt = new Date(date.getFullYear(), date.getMonth() + 1, 1);

    return new Date(dt.setDate(dt.getDate() - 1));
  },
  format: function format(date, _format, monthNames) {
    monthNames = monthNames || defMonthNames;
    if (typeof date === 'string') {
      date = new Date(date.replace(/-/g, '/'));
    } else {
      date = new Date(date);
    }

    var map = {
      'M': date.getMonth() + 1,
      'd': date.getDate(),
      'h': date.getHours(),
      'm': date.getMinutes(),
      's': date.getSeconds(),
      'q': Math.floor((date.getMonth() + 3) / 3),
      'S': date.getMilliseconds()
    };

    _format = _format.replace(/([yMdhmsqS])+/g, function (all, t) {
      var v = map[t];
      if (v !== undefined) {
        if (all === 'MMMM') {
          return monthNames[v - 1];
        }
        if (all === 'MMM') {
          return shortMonth[v - 1];
        }
        if (all.length > 1) {
          v = '0' + v;
          v = v.substr(v.length - 2);
        }
        return v;
      } else if (t === 'y') {
        return String(date.getFullYear()).substr(4 - all.length);
      }
      return all;
    });
    return _format;
  }
};

module.exports = dateFunc;

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  weekNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  titleFormat: 'MMMM'
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apolloClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_client__ = __webpack_require__(64);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default.a; });




var networkInterface = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_apollo_client__["a" /* createNetworkInterface */])({
  uri: "https://holidays.kaleidos.net/graphql",
  opts: {
    Accept: 'application/json',
    credentials: 'include'
  }
});

var apolloClient = new __WEBPACK_IMPORTED_MODULE_1_apollo_client__["b" /* default */]({
  networkInterface: networkInterface,
  addTypename: undefined
});



/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_store__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);








__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.holidays = __webpack_require__.i({"NODE_ENV":"production","GRAPHQL_API":"https://holidays.kaleidos.net/graphql","ROOT_ELEM":"#app","LOGIN_ROUTE":"https://holidays.kaleidos.net/api/login?success_url=https://holidays.kaleidos.net/&failure_url=https://holidays.kaleidos.net/login-ko","LOGOUT":"https://holidays.kaleidos.net/api/logout","KALEIDERS_CALENDAR":"https://calendar.google.com/calendar/embed?src=kaleidos.net_01kf4sf4gvmb1gqfsqm7rfl6d8%40group.calendar.google.com&ctz=Europe/Madrid","TOTAL_MONTHS":12});

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  store: __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  el: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.holidays.ROOT_ELEM,
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App___default.a
  },
  template: '<App/>'
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_store__ = __webpack_require__(18);



/* harmony default export */ __webpack_exports__["a"] = (function (router) {
  router.beforeEach(function (to, from, next) {
    var REQUIRE_AUTH = to.matched.some(function (record) {
      return record.meta.requireAuth;
    });

    if (REQUIRE_AUTH) {
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].getters.getMe).length) {
        return __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('me').then(next).catch(function () {
          return next({
            path: '/login'
          });
        });
      }
    }

    return next();
  });

  router.beforeEach(function (to, from, next) {
    var REQUIRE_ADMIN = to.matched.some(function (record) {
      return record.meta.requireAdmin;
    });

    if (REQUIRE_ADMIN && !__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].getters.isAdmin) {
      return next({
        path: '/'
      });
    }

    return next();
  });
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "me", function() { return me; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "importHolidays", function() { return importHolidays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vacations", function() { return vacations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "holidays", function() { return holidays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStartDate", function() { return setStartDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEndDate", function() { return setEndDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setHolidayName", function() { return setHolidayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setShowMore", function() { return setShowMore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentView", function() { return setCurrentView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSelectDay", function() { return setSelectDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSelectedYear", function() { return setSelectedYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUpdateVacations", function() { return setUpdateVacations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUpdateHolidays", function() { return setUpdateHolidays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setApiError", function() { return setApiError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setImportHolidaysSuccess", function() { return setImportHolidaysSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateEvents", function() { return updateEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelHolidays", function() { return cancelHolidays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelRemove", function() { return cancelRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addHolidays", function() { return addHolidays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEditingId", function() { return setEditingId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeHolidays", function() { return removeHolidays; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql__ = __webpack_require__(77);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    query {\n      me {\n        id\n        name\n        picture\n        role\n        remainingDays\n        daysPerYear {\n          edges {\n            node {\n              id\n              year\n              remainingDays\n              kaleiderId\n              holidayType\n              carryOver\n            }\n          }\n        }\n      }\n    }\n  '], ['\n    query {\n      me {\n        id\n        name\n        picture\n        role\n        remainingDays\n        daysPerYear {\n          edges {\n            node {\n              id\n              year\n              remainingDays\n              kaleiderId\n              holidayType\n              carryOver\n            }\n          }\n        }\n      }\n    }\n  ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    mutation importHolidays($input:ImportHolidaysInput!) {\n      importHolidays(input:$input) {\n        ok\n        holidays {\n          date\n          name\n        }\n      }\n    }\n  '], ['\n    mutation importHolidays($input:ImportHolidaysInput!) {\n      importHolidays(input:$input) {\n        ok\n        holidays {\n          date\n          name\n        }\n      }\n    }\n  ']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    query ($kaleiderId: ID, $fromDate: String, $toDate: String) {\n      vacations(kaleiderId: $kaleiderId, fromDate: $fromDate, toDate: $toDate) {\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n        edges {\n          node {\n            id\n            startDate\n            endDate\n            workingDays\n            kaleider {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  '], ['\n    query ($kaleiderId: ID, $fromDate: String, $toDate: String) {\n      vacations(kaleiderId: $kaleiderId, fromDate: $fromDate, toDate: $toDate) {\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n        edges {\n          node {\n            id\n            startDate\n            endDate\n            workingDays\n            kaleider {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  ']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    query holidays {\n      holidays {\n        edges {\n          node {\n            date\n            name\n          }\n        }\n      }\n    }\n  '], ['\n    query holidays {\n      holidays {\n        edges {\n          node {\n            date\n            name\n          }\n        }\n      }\n    }\n  ']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      mutation addVacation($input:AddVacationInput!) {\n        addVacation(input:$input) {\n          ok\n          errors\n          vacation {\n            id\n            startDate\n            endDate\n            workingDays\n          }\n        }\n      }\n    '], ['\n      mutation addVacation($input:AddVacationInput!) {\n        addVacation(input:$input) {\n          ok\n          errors\n          vacation {\n            id\n            startDate\n            endDate\n            workingDays\n          }\n        }\n      }\n    ']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    mutation addHoliday($input:AddHolidayInput!) {\n      addHoliday(input:$input) {\n        ok\n        errors\n        holiday {\n          id\n          date\n        }\n      }\n    }\n  '], ['\n    mutation addHoliday($input:AddHolidayInput!) {\n      addHoliday(input:$input) {\n        ok\n        errors\n        holiday {\n          id\n          date\n        }\n      }\n    }\n  ']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      mutation deleteVacation($input:DeleteVacationInput!) {\n        deleteVacation(input: $input) {\n          ok\n          errors\n        }\n      }\n    '], ['\n      mutation deleteVacation($input:DeleteVacationInput!) {\n        deleteVacation(input: $input) {\n          ok\n          errors\n        }\n      }\n    ']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    mutation deleteHoliday($input: DeleteHolidayInput!) {\n      deleteHoliday(input: $input) {\n        ok\n        errors\n      }\n    }\n  '], ['\n    mutation deleteHoliday($input: DeleteHolidayInput!) {\n      deleteHoliday(input: $input) {\n        ok\n        errors\n      }\n    }\n  ']);



var me = function me(_ref) {
  var commit = _ref.commit,
      state = _ref.state;

  var getMe = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__graphql__["a" /* gql */])(_templateObject);

  return __WEBPACK_IMPORTED_MODULE_1__graphql__["b" /* graphClient */].query({
    query: getMe,
    forceFetch: true
  }).then(function (user) {
    var daysPerYear = user.data.me.daysPerYear.edges.map(function (item) {
      return item.node;
    }).filter(function (d) {
      return d.remainingDays > 0 && d.year <= state.selectedYear;
    });

    var hasCarryOverDays = daysPerYear.filter(function (d) {
      return d.carryOver;
    }).length > 0;
    if (hasCarryOverDays) {
      daysPerYear = daysPerYear.filter(function (d) {
        return d.carryOver;
      });
    } else {
      daysPerYear = daysPerYear.filter(function (d) {
        return !d.carryOver && d.year === state.selectedYear;
      });
    }

    var remainingDays = daysPerYear.reduce(function (ac, v) {
      return ac + v.remainingDays;
    }, 0);

    return commit('ME', {
      id: user.data.me.id,
      daysPerYear: daysPerYear,
      name: user.data.me.name,
      picture: user.data.me.picture,
      remainingDays: remainingDays,
      role: user.data.me.role,
      hasCarryOverDays: hasCarryOverDays });
  });
};

var importHolidays = function importHolidays(_ref2) {
  var commit = _ref2.commit,
      state = _ref2.state;

  var mutationImportHolidays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__graphql__["a" /* gql */])(_templateObject2);

  return __WEBPACK_IMPORTED_MODULE_1__graphql__["b" /* graphClient */].mutate({
    mutation: mutationImportHolidays,
    variables: {
      input: {}
    }
  }).then(function (data) {
    if (data.data.importHolidays.ok) {
      commit('SET_IMPORT_HOLIDAYS_SUCCESS', true);
    } else {
      throw data.data;
    }
  }).catch(function (err) {
    console.error(err);
  });
};

var vacations = function vacations(_ref3) {
  var commit = _ref3.commit,
      state = _ref3.state;

  var getVacations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__graphql__["a" /* gql */])(_templateObject3);

  var vacations = {
    kaleiderId: state.me.id,
    fromDate: state.selectedYear - 1 + '-09-01',
    toDate: state.selectedYear + 1 + '-03-31'
  };

  return __WEBPACK_IMPORTED_MODULE_1__graphql__["b" /* graphClient */].query({
    query: getVacations,
    variables: vacations,
    forceFetch: true
  }).then(function (data) {
    var totalVacations = data.data.vacations.edges.map(function (res) {
      return res.node;
    });
    return commit('GET_VACATIONS', totalVacations);
  }).catch(function (err) {
    console.error(err);
  });
};

var holidays = function holidays(_ref4) {
  var commit = _ref4.commit,
      state = _ref4.state;

  var getHolidays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__graphql__["a" /* gql */])(_templateObject4);

  return __WEBPACK_IMPORTED_MODULE_1__graphql__["b" /* graphClient */].query({
    query: getHolidays,
    forceFetch: true
  }).then(function (data) {
    var TOTAL_HOLIDAYS = data.data.holidays.edges.map(function (res) {
      return res.node;
    });
    return commit('GET_HOLIDAYS', TOTAL_HOLIDAYS);
  }).catch(function (err) {
    console.log(err);
  });
};

var setStartDate = function setStartDate(_ref5, data) {
  var commit = _ref5.commit;

  return commit('SET_START_DATE', data);
};

var setEndDate = function setEndDate(_ref6, data) {
  var commit = _ref6.commit;

  return commit('SET_END_DATE', data);
};

var setHolidayName = function setHolidayName(_ref7, data) {
  var commit = _ref7.commit;

  return commit('SET_HOLIDAY_NAME', data);
};

var setShowMore = function setShowMore(_ref8, data) {
  var commit = _ref8.commit;

  return commit('SET_SHOW_MORE', data);
};

var setCurrentView = function setCurrentView(_ref9, data) {
  var commit = _ref9.commit;

  return commit('SET_CURRENT_VIEW', data);
};

var setSelectDay = function setSelectDay(_ref10, data) {
  var commit = _ref10.commit;

  return commit('SET_SELECT_DAY', data);
};

var setSelectedYear = function setSelectedYear(_ref11, data) {
  var commit = _ref11.commit;

  return commit('SET_SELECT_YEAR', data);
};

var setUpdateVacations = function setUpdateVacations(_ref12, data) {
  var commit = _ref12.commit;

  return commit('SET_UPDATE_VACATIONS', data);
};

var setUpdateHolidays = function setUpdateHolidays(_ref13, data) {
  var commit = _ref13.commit;

  return commit('SET_UPDATE_HOLIDAYS', data);
};

var setApiError = function setApiError(_ref14, data) {
  var commit = _ref14.commit;

  return commit('SET_API_ERROR', data);
};

var setImportHolidaysSuccess = function setImportHolidaysSuccess(_ref15, data) {
  var commit = _ref15.commit;

  return commit('SET_IMPORT_HOLIDAYS_SUCCESS', data);
};

var updateEvents = function updateEvents(_ref16, data) {
  var commit = _ref16.commit;

  if (data) {
    return commit('UPDATE_VACATIONS');
  } else {
    return commit('UPDATE_HOLIDAYS');
  }
};

var cancelHolidays = function cancelHolidays(_ref17, data) {
  var commit = _ref17.commit;

  if (data) {
    return commit('CANCEL_VACATIONS');
  } else {
    return commit('CANCEL_HOLIDAYS');
  }
};

var cancelRemove = function cancelRemove(_ref18) {
  var commit = _ref18.commit;

  return commit('CANCEL_REMOVE');
};

var addHolidays = function addHolidays(_ref19, data) {
  var commit = _ref19.commit,
      state = _ref19.state;

  if (data) {
    var mutateVacationsQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__graphql__["a" /* gql */])(_templateObject5);
    var vacation = {
      startDate: state.startDate,
      endDate: state.endDate
    };

    return __WEBPACK_IMPORTED_MODULE_1__graphql__["b" /* graphClient */].mutate({
      mutation: mutateVacationsQuery,
      variables: {
        input: vacation
      }
    }).then(function (data) {
      if (data.data.addVacation.ok) {
        commit('ADD_VACATIONS', data);
      } else {
        state.apiError = data.data.addVacation.errors[0];
      }
    }).catch(function (err) {
      console.error(err);
    });
  }
  var mutateHolidaysQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__graphql__["a" /* gql */])(_templateObject6);
  var holidays = {
    date: state.startDate,
    name: state.holidayName
  };

  return __WEBPACK_IMPORTED_MODULE_1__graphql__["b" /* graphClient */].mutate({
    mutation: mutateHolidaysQuery,
    variables: {
      input: holidays
    }
  }).then(function (data) {
    if (data.data.addHoliday.ok) {
      commit('ADD_HOLIDAYS', data);
    } else {
      state.apiError = data.data.addHoliday.errors[0];
    }
  }).catch(function (err) {
    console.error(err);
  });
};

var setEditingId = function setEditingId(_ref20, data) {
  var commit = _ref20.commit,
      state = _ref20.state;

  return commit('EDIT_ID', data);
};

var removeHolidays = function removeHolidays(_ref21, data) {
  var commit = _ref21.commit,
      state = _ref21.state;

  if (data) {
    var mutateVacationsQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__graphql__["a" /* gql */])(_templateObject7);
    var vacation = {
      id: state.editingId
    };

    return __WEBPACK_IMPORTED_MODULE_1__graphql__["b" /* graphClient */].mutate({
      mutation: mutateVacationsQuery,
      variables: {
        input: vacation
      }
    }).then(function (data) {
      if (data.data.deleteVacation.ok) {
        commit('REMOVE_VACATIONS');
      } else {
        state.apiError = data.data.deleteVacation.errors[0];
      }
    }).catch(function (err) {
      console.error(err);
    });
  }
  var mutateHolidaysQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__graphql__["a" /* gql */])(_templateObject8);
  var holidays = {
    date: state.startDate
  };

  return __WEBPACK_IMPORTED_MODULE_1__graphql__["b" /* graphClient */].mutate({
    mutation: mutateHolidaysQuery,
    variables: {
      input: holidays
    }
  }).then(function (data) {
    if (data.data.deleteHoliday.ok) {
      commit('REMOVE_HOLIDAYS');
    } else {
      state.apiError = data.data.deleteHoliday.errors[0];
    }
  }).catch(function (err) {
    console.error(err);
  });
};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMe", function() { return getMe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAdmin", function() { return isAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVacations", function() { return getVacations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHolidays", function() { return getHolidays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewVacations", function() { return getNewVacations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewHolidays", function() { return getNewHolidays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStartDate", function() { return getStartDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEndDate", function() { return getEndDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBookedDays", function() { return getBookedDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShowMore", function() { return getShowMore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentView", function() { return getCurrentView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectDay", function() { return getSelectDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedYear", function() { return getSelectedYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEditingId", function() { return getEditingId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUpdateVacations", function() { return getUpdateVacations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUpdateHolidays", function() { return getUpdateHolidays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getApiError", function() { return getApiError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAvailableDays", function() { return getAvailableDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getKaleiders", function() { return getKaleiders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImportSuccess", function() { return getImportSuccess; });
var getMe = function getMe(state) {
  return state.me;
};
var isAdmin = function isAdmin(state) {
  return state.me.role === 'ADMIN';
};
var getVacations = function getVacations(state) {
  return state.vacations;
};
var getHolidays = function getHolidays(state) {
  return state.holidays;
};
var getNewVacations = function getNewVacations(state) {
  return state.newVacations;
};
var getNewHolidays = function getNewHolidays(state) {
  return state.newHolidays;
};
var getStartDate = function getStartDate(state) {
  return state.startDate;
};
var getEndDate = function getEndDate(state) {
  return state.endDate;
};
var getBookedDays = function getBookedDays(state) {
  return state.bookedDays;
};
var getShowMore = function getShowMore(state) {
  return state.showMore;
};
var getCurrentView = function getCurrentView(state) {
  return state.currentView;
};
var getSelectDay = function getSelectDay(state) {
  return state.selectDay;
};
var getSelectedYear = function getSelectedYear(state) {
  return state.selectedYear;
};
var getEditingId = function getEditingId(state) {
  return state.editingId;
};
var getUpdateVacations = function getUpdateVacations(state) {
  return state.updateVacations;
};
var getUpdateHolidays = function getUpdateHolidays(state) {
  return state.updateHolidays;
};
var getApiError = function getApiError(state) {
  return state.apiError;
};
var getAvailableDays = function getAvailableDays(state) {
  return state.availableDays;
};
var getKaleiders = function getKaleiders(state) {
  return state.kaleiders;
};
var getImportSuccess = function getImportSuccess(state) {
  return state.importVacationsSuccess;
};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ME", function() { return ME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KALEIDERS", function() { return KALEIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_KALEIDER_DAY_PER_YEAR", function() { return SET_KALEIDER_DAY_PER_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_VACATIONS", function() { return GET_VACATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_HOLIDAYS", function() { return GET_HOLIDAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_START_DATE", function() { return SET_START_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_END_DATE", function() { return SET_END_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_HOLIDAY_NAME", function() { return SET_HOLIDAY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SHOW_MORE", function() { return SET_SHOW_MORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_API_ERROR", function() { return SET_API_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CURRENT_VIEW", function() { return SET_CURRENT_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SELECT_DAY", function() { return SET_SELECT_DAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SELECT_YEAR", function() { return SET_SELECT_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_IMPORT_HOLIDAYS_SUCCESS", function() { return SET_IMPORT_HOLIDAYS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_VACATIONS", function() { return UPDATE_VACATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_HOLIDAYS", function() { return UPDATE_HOLIDAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_VACATIONS", function() { return ADD_VACATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_HOLIDAYS", function() { return ADD_HOLIDAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_VACATIONS", function() { return CANCEL_VACATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_HOLIDAYS", function() { return CANCEL_HOLIDAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_REMOVE", function() { return CANCEL_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDIT_ID", function() { return EDIT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_UPDATE_VACATIONS", function() { return SET_UPDATE_VACATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_UPDATE_HOLIDAYS", function() { return SET_UPDATE_HOLIDAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_VACATIONS", function() { return REMOVE_VACATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_HOLIDAYS", function() { return REMOVE_HOLIDAYS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var ME = function ME(state) {
  var me = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  state.me = me;
};

var KALEIDERS = function KALEIDERS(state, data) {
  state.kaleiders = data;
};

var SET_KALEIDER_DAY_PER_YEAR = function SET_KALEIDER_DAY_PER_YEAR(state, data) {
  var KALEIDER = state.kaleiders.find(function (item) {
    return item.id === data.kaleiderId;
  });
  var YEAR = KALEIDER.daysPerYear.findIndex(function (item) {
    return item.year === data.daysPerYear.year;
  });

  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(KALEIDER.daysPerYear, YEAR, data.daysPerYear);

  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(KALEIDER, 'remainingDays', KALEIDER.daysPerYear.reduce(function (reducer, valorActual) {
    return reducer + valorActual.remainingDays;
  }, 0));
};

var GET_VACATIONS = function GET_VACATIONS(state, data) {
  state.vacations = data;
};

var GET_HOLIDAYS = function GET_HOLIDAYS(state, data) {
  state.holidays = data;
};

var SET_START_DATE = function SET_START_DATE(state, data) {
  state.startDate = data;
};

var SET_END_DATE = function SET_END_DATE(state, data) {
  state.endDate = data;
};

var SET_HOLIDAY_NAME = function SET_HOLIDAY_NAME(state, data) {
  state.holidayName = data;
};

var SET_SHOW_MORE = function SET_SHOW_MORE(state, data) {
  state.showMore = data;
};

var SET_API_ERROR = function SET_API_ERROR(state) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  state.apiError = data;
};

var SET_CURRENT_VIEW = function SET_CURRENT_VIEW(state, data) {
  state.currentView = data;
};

var SET_SELECT_DAY = function SET_SELECT_DAY(state, data) {
  state.selectDay = data;
};

var SET_SELECT_YEAR = function SET_SELECT_YEAR(state, data) {
  state.selectedYear = data;
};

var SET_IMPORT_HOLIDAYS_SUCCESS = function SET_IMPORT_HOLIDAYS_SUCCESS(state, data) {
  state.importVacationsSuccess = data;
};

var UPDATE_VACATIONS = function UPDATE_VACATIONS(state) {
  var newVacations = [{
    'startDate': state.startDate,
    'endDate': state.endDate,
    'kaleider': {
      'id': state.me.id,
      'name': state.me.name
    }
  }];
  state.newVacations = newVacations;

  var start = new Date(state.startDate);
  var end = new Date(state.endDate);
  var dif = end - start;
  var dias = Math.floor(dif / (1000 * 60 * 60 * 24)) + 1;

  var bookedDays = 0;
  for (var day = 0; day < dias; day++) {
    if (day > 0) {
      start.setDate(start.getDate() + 1);
    } else {
      start.setDate(start.getDate());
    }
    var weekDay = start.getDay();

    if (weekDay > 0 && weekDay < 6) {
      var thisDayEvents = [];
      var thisDayPublic = [];
      if (state.vacations.length) {
        thisDayEvents = state.vacations.filter(function (vacations) {
          var dt = new Date(vacations.startDate);
          var st = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
          var ed = vacations.endDate ? new Date(vacations.endDate) : st;

          var startUtc = new Date(start);
          startUtc.setHours(0, 0, 0, 0);
          dt.setHours(0, 0, 0, 0);
          st.setHours(0, 0, 0, 0);
          ed.setHours(0, 0, 0, 0);

          return start >= st && start <= ed;
        });
      }
      if (state.holidays.length) {
        thisDayPublic = state.holidays.filter(function (holidays) {
          var dt = new Date(holidays.date);
          var st = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
          var ed = holidays.date ? new Date(holidays.date) : st;

          var startUtc = new Date(start);
          startUtc.setHours(0, 0, 0, 0);
          dt.setHours(0, 0, 0, 0);
          st.setHours(0, 0, 0, 0);
          ed.setHours(0, 0, 0, 0);

          return startUtc >= st && startUtc <= ed;
        });
      }
      if (!thisDayEvents.length && !thisDayPublic.length) {
        bookedDays++;
      }
    }
  }
  state.bookedDays = bookedDays;
};

var UPDATE_HOLIDAYS = function UPDATE_HOLIDAYS(state) {
  var newHolidays = [{
    'date': state.startDate
  }];
  state.newHolidays = newHolidays;
};

var ADD_VACATIONS = function ADD_VACATIONS(state, data) {
  state.vacations.push(state.newVacations[0]);
  state.newVacations = [];
  state.startDate = '';
  state.endDate = '';
  state.selectDay = [];
  state.bookedDays = 0;
  state.showMore = '';
  state.updateVacations = true;
};

var ADD_HOLIDAYS = function ADD_HOLIDAYS(state, data) {
  state.holidays.push(state.newHolidays[0]);
  state.newHolidays = [];
  state.startDate = '';
  state.endDate = '';
  state.selectDay = [];
  state.bookedDays = 0;
  state.showMore = '';
  state.updateHolidays = true;
};

var CANCEL_VACATIONS = function CANCEL_VACATIONS(state) {
  state.newVacations = [];
  state.startDate = '';
  state.endDate = '';
  state.selectDay = [];
  state.bookedDays = 0;
  state.showMore = '';
  state.apiError = '';
};

var CANCEL_HOLIDAYS = function CANCEL_HOLIDAYS(state) {
  state.newHolidays = [];
  state.startDate = '';
  state.endDate = '';
  state.selectDay = [];
  state.bookedDays = 0;
  state.showMore = '';
};

var CANCEL_REMOVE = function CANCEL_REMOVE(state) {
  state.newVacations = [];
  state.newHolidays = [];
  state.startDate = '';
  state.endDate = '';
  state.selectDay = [];
  state.bookedDays = 0;
  state.showMore = '';
  state.editingId = '';
};

var EDIT_ID = function EDIT_ID(state, data) {
  state.editingId = data;
};

var SET_UPDATE_VACATIONS = function SET_UPDATE_VACATIONS(state, data) {
  state.updateVacations = data;
};

var SET_UPDATE_HOLIDAYS = function SET_UPDATE_HOLIDAYS(state, data) {
  state.updateHolidays = data;
};

var REMOVE_VACATIONS = function REMOVE_VACATIONS(state) {
  state.newVacations = [];
  state.startDate = '';
  state.endDate = '';
  state.selectDay = [];
  state.bookedDays = 0;
  state.showMore = '';
  state.editingId = '';
  state.updateVacations = true;
};

var REMOVE_HOLIDAYS = function REMOVE_HOLIDAYS(state) {
  state.newHolidays = [];
  state.startDate = '';
  state.endDate = '';
  state.selectDay = [];
  state.bookedDays = 0;
  state.showMore = '';
  state.editingId = '';
  state.updateHolidays = true;
};

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_store__ = __webpack_require__(18);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  store: __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */]
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BookHolidayPopup',
  data: function data() {
    return {
      limitDaysText: 'Zero available days',
      holidaysText: {
        text_title: 'Book holiday',
        text_days: ' day(s), ',
        text_remaining: ' remaining',
        hint_add_days: 'Click last day'
      },
      holidaysBookedText: {
        text_title: 'Booked holiday'
      },
      publicText: {
        text_title: 'Mark as public holiday'
      },
      publicBookedText: {
        text_title: 'Public holiday'
      },
      newHolidayName: undefined
    };
  },
  props: {
    startDate: String,
    endDate: String,
    bookedDays: Number,
    isHolidaysCalendar: Boolean,
    editing: String,
    boxTop: Boolean,
    boxLeft: Boolean,
    workingDays: Number,
    holidayName: String,
    showOnly: Boolean
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['addHolidays', 'cancelHolidays', 'cancelRemove', 'removeHolidays', 'setHolidayName', 'setApiError']), {
    saveBooked: function saveBooked() {
      this.setHolidayName(this.newHolidayName);
      this.addHolidays(this.isHolidaysCalendar);
      this.newHolidayName = undefined;
    },
    cancelBooked: function cancelBooked() {
      if (this.showOnly) {
        this.$emit('show', false);
      }
      this.cancelHolidays(this.isHolidaysCalendar);
    },
    cancelRemoveHolidays: function cancelRemoveHolidays() {
      if (this.getApiError) {
        this.setApiError();
      }
      this.cancelRemove();
    },
    removeBooked: function removeBooked() {
      this.removeHolidays(this.isHolidaysCalendar);
    },
    canBeDeleted: function canBeDeleted() {
      var now = new Date();
      now.setHours(0, 0, 0, 0, 0);
      return !this.isHolidaysCalendar || now < new Date(this.startDate);
    },
    isDisabled: function isDisabled() {
      if (!this.isHolidaysCalendar) {
        return false;
      }
      return this.getMe.remainingDays < 1;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getMe', 'getApiError']), {
    end: function end() {
      return this.startDate === this.endDate ? 'same day' : this.endDate;
    }
  }),
  updated: function updated() {
    this.setApiError('');
    this.$emit('show', false);
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Month_Month__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Month_Month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Month_Month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Calendar',
  components: {
    Month: __WEBPACK_IMPORTED_MODULE_2__Month_Month___default.a
  },
  data: function data() {
    return {
      totalMonths: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.config.holidays.TOTAL_MONTHS,
      isHolidaysCalendar: true
    };
  },
  created: function created() {
    this.vacations();
    this.holidays();
    this.cancelHolidays();
    this.cancelHolidays(this.isHolidaysCalendar);
  },

  watch: {
    getSelectedYear: function getSelectedYear() {
      this.vacations();
    },
    getUpdateVacations: function getUpdateVacations(val) {
      this.vacations();
      this.setUpdateVacations(false);
    },
    getUpdateHolidays: function getUpdateHolidays(val) {
      this.holidays();
      this.setUpdateHolidays(false);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['vacations', 'holidays', 'cancelHolidays', 'setUpdateVacations', 'setUpdateHolidays']), {
    setMonth: function setMonth(n) {
      var year = this.getSelectedYear;
      var everyMonth = new Date(year, n - 1);
      return everyMonth;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getHolidays', 'getVacations', 'getEditingId', 'getSelectedYear', 'getUpdateVacations', 'getUpdateHolidays']), {
    events: function events() {
      var currentVacations = [];
      if (this.getVacations.length) {
        currentVacations = this.getVacations.map(function (vacations) {
          var HOLIDAY_CLASS = 'holiday';
          return {
            id: vacations.id,
            start: vacations.startDate,
            end: vacations.endDate,
            workingDays: vacations.workingDays,
            cssClass: HOLIDAY_CLASS
          };
        });
      }
      var currentHolidays = [];
      if (this.getHolidays.length) {
        currentHolidays = this.getHolidays.map(function (holidays) {
          var PUBLIC_CLASS = 'public';
          return {
            start: holidays.date,
            end: holidays.date,
            name: holidays.name,
            cssClass: PUBLIC_CLASS
          };
        });
      }
      var allEvents = currentHolidays.concat(currentVacations);
      return allEvents;
    }
  })
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GoogleBtn',
  data: function data() {
    return {
      loginRoute: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.holidays.LOGIN_ROUTE
    };
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuCalendar',
  data: function data() {
    return {
      kaleidersCalendar: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.config.holidays.KALEIDERS_CALENDAR,
      AVAILABLE_DAYS: 'available days',
      BOOKED_HOLIDAY: 'Booked holiday',
      PUBLIC_HOLIDAY: 'Public holiday',
      IMPORT_SUCCESS: 'Holidays updated :)',
      shrinkedTitle: false,
      editYear: false,
      currentYear: new Date().getFullYear(),
      lastYear: new Date().getFullYear() - 1
    };
  },
  props: {
    showBookedHolidays: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('click', this.handleClick);
  },
  destroyed: function destroyed() {
    document.removeEventListener('click', this.handleClick);
    window.removeEventListener('scroll', this.handleScroll);
  },

  watch: {
    getUpdateVacations: function getUpdateVacations(val) {
      this.me();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getMe', 'getSelectedYear', 'getUpdateVacations', 'getImportSuccess']), {
    yearList: function yearList() {
      var years = [new Date().getFullYear() + 1];
      for (var i = 0; i < 3; i++) {
        years.push(new Date().getFullYear() - i);
      }
      return years;
    },
    allYearsNum: function allYearsNum() {
      var years = [];

      this.getMe.daysPerYear.reduce(function (reducer, valorActual) {
        if (valorActual.remainingDays) {
          reducer.push({
            year: valorActual.year.toString(),
            num: valorActual.remainingDays,
            info: valorActual.holidayType
          });
        }

        return reducer;
      }, years);

      return years.sort().reverse();
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['setSelectedYear', 'me', 'importHolidays', 'setImportHolidaysSuccess']), {
    handleClick: function handleClick(ev) {
      if (!this.$refs.dropdown.contains(ev.target) && !this.$refs.arrow.contains(ev.target)) {
        this.editYear = false;
      }
    },
    handleScroll: function handleScroll() {
      var distanceY = window.pageYOffset || document.documentElement.scrollTop;
      var shrinkOn = 80;
      var shrinkOff = 1;
      var headerEl = document.querySelector('.titleCalendarContainer');

      if (!this.shrinkedTitle && distanceY > shrinkOn) {
        this.shrinkedTitle = true;
        headerEl.classList.add('smaller');
      } else if (this.shrinkedTitle && distanceY < shrinkOff) {
        this.shrinkedTitle = false;
        headerEl.classList.remove('smaller');
      }
    },
    showYear: function showYear() {
      this.editYear = !this.editYear;
    },
    changeYear: function changeYear(year) {
      this.setSelectedYear(year);
      this.showYear();
      this.me();
    },
    importCalendar: function importCalendar() {
      this.importHolidays();
    },
    changeSuccess: function changeSuccess() {
      this.setImportHolidaysSuccess(false);
    }
  })
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dateFunc__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dateFunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dateFunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BookHolidayPopup_BookHolidayPopup__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BookHolidayPopup_BookHolidayPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BookHolidayPopup_BookHolidayPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__langSets__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Month',
  components: {
    BookHolidayPopup: __WEBPACK_IMPORTED_MODULE_2__BookHolidayPopup_BookHolidayPopup___default.a
  },
  props: {
    currentDate: {},
    events: null,
    isHolidaysCalendar: Boolean
  },
  created: function created() {
    this.dispatchEvent();
  },
  data: function data() {
    return {
      titleFormat: __WEBPACK_IMPORTED_MODULE_3__langSets__["a" /* default */].titleFormat,
      monthNames: __WEBPACK_IMPORTED_MODULE_3__langSets__["a" /* default */].monthNames,
      firstDay: 1,
      weekMask: [1, 2, 3, 4, 5, 6, 7],
      eventLimit: 1,
      morePos: {
        top: 0,
        left: 0
      },
      remainDays: 0,
      title: '',
      headDate: this.currentDate,
      showMore: false,
      selectDay: [],
      month: 0,
      fridayNumber: 4,
      mondayNumber: 0,
      saturdayNumber: 6,
      daysOfWeek: 7,
      classHoliday: 'holiday',
      classPublic: 'public',
      classNewHoliday: 'newHoliday',
      classNewHolidayPublic: 'newHolidayPublic',
      formatDate: 'yyyy-MM-dd',
      boxTop: false,
      boxLeft: false,
      workingDays: 0,
      holidayName: '',
      showOnly: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getNewVacations', 'getNewHolidays', 'getSelectDay', 'getStartDate', 'getEndDate', 'getBookedDays', 'getShowMore', 'getEditingId', 'getSelectedYear', 'getMe']), {
    weekNames: function weekNames() {
      var arr = __WEBPACK_IMPORTED_MODULE_3__langSets__["a" /* default */].weekNames;
      return arr.slice(this.firstDay).concat(arr.slice(0, this.firstDay));
    },
    currentDates: function currentDates() {
      return this.getCalendar();
    },
    firstDay: function firstDay(val) {
      var res = parseInt(val);
      return res >= this.mondayNumber && res <= this.saturdayNumber;
    },
    newEvents: function newEvents() {
      var _this = this;

      if (this.isHolidaysCalendar) {
        var newVacations = {};
        if (this.getNewVacations.length) {
          newVacations = this.getNewVacations.map(function (vacations) {
            return {
              start: vacations.startDate,
              end: vacations.endDate,
              cssClass: _this.classNewHoliday
            };
          });
        }
        return newVacations;
      } else {
        var newHolidays = {};
        if (this.getNewHolidays.length) {
          newHolidays = this.getNewHolidays.map(function (holidays) {
            return {
              start: holidays.date,
              end: holidays.date,
              cssClass: _this.classNewHolidayPublic
            };
          });
        }
        return newHolidays;
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['setSelectDay', 'setStartDate', 'setEndDate', 'setShowMore', 'updateEvents', 'setEditingId', 'cancelHolidays', 'cancelRemove']), {
    changeShow: function changeShow() {
      this.showOnly = false;
    },
    isOpened: function isOpened() {
      return this.getShowMore === this.title;
    },
    getCalendar: function getCalendar() {
      var now = new Date();
      now.setHours(0, 0, 0, 0);
      var current = new Date(this.currentDate);

      var startDate = __WEBPACK_IMPORTED_MODULE_1__dateFunc___default.a.getStartDate(current);

      var curWeekDay = startDate.getDay();

      var diff = parseInt(this.firstDay) - curWeekDay;
      diff = diff > this.mondayNumber ? diff - this.daysOfWeek : diff;

      startDate.setDate(startDate.getDate() + diff);
      var calendar = [];

      for (var perWeek = this.mondayNumber; perWeek < this.saturdayNumber; perWeek++) {
        var week = [];

        for (var perDay = this.mondayNumber; perDay < this.daysOfWeek; perDay++) {
          week.push({
            monthDay: startDate.getDate(),
            isToday: now.toDateString() === startDate.toDateString(),
            isFutureDate: startDate > now,
            isCurMonth: startDate.getMonth() === current.getMonth(),
            weekDay: perDay,
            date: new Date(startDate),
            events: this.slotEvents(startDate, this.events),
            newVacations: this.slotEvents(startDate, this.newEvents)
          });

          startDate.setDate(startDate.getDate() + 1);
        }
        calendar.push(week);
      }

      return calendar;
    },
    slotEvents: function slotEvents(date, events) {
      if (!events.length) {
        return false;
      }

      var thisDayEvents = events.filter(function (day) {
        var dt = new Date(day.start);
        var st = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
        var ed = day.end ? new Date(day.end) : st;
        return date >= st && date <= ed;
      }).sort(function (a, b) {
        if (!a.cellIndex) return 1;
        if (!b.cellIndex) return -1;
        return a.cellIndex - b.cellIndex;
      });

      for (var i = 0; i < thisDayEvents.length; i++) {
        thisDayEvents[i].cellIndex = thisDayEvents[i].cellIndex || i + 1;
        thisDayEvents[i].isShow = true;
        if (thisDayEvents[i].cellIndex === i + 1 || i > 2) continue;
        thisDayEvents.splice(i, 0, {
          cellIndex: i + 1,
          start: __WEBPACK_IMPORTED_MODULE_1__dateFunc___default.a.format(date, this.formatDate),
          end: __WEBPACK_IMPORTED_MODULE_1__dateFunc___default.a.format(date, this.formatDate)
        });
      }

      return thisDayEvents;
    },
    isStart: function isStart(eventDate, date) {
      var st = new Date(eventDate);
      return st.toDateString() === date.toDateString();
    },
    isEnd: function isEnd(eventDate, date) {
      var ed = new Date(eventDate);
      return ed.toDateString() === date.toDateString();
    },
    isHoliday: function isHoliday(eventDate, date) {
      if (!eventDate) {
        return false;
      }
      if (eventDate.cssClass === this.classHoliday) {
        return true;
      }
      return false;
    },
    isNewHoliday: function isNewHoliday(eventDate, date) {
      if (!eventDate) {
        return false;
      }
      if (eventDate.cssClass === this.classNewHoliday) {
        return true;
      }
      return false;
    },
    isNewHolidayPublic: function isNewHolidayPublic(eventDate, date) {
      if (!eventDate) {
        return false;
      }
      if (eventDate.cssClass === this.classNewHolidayPublic) {
        return true;
      }
      return false;
    },
    isPublic: function isPublic(eventDate, date) {
      if (!eventDate) {
        return false;
      }
      if (eventDate.cssClass === this.classPublic) {
        return true;
      }
      return false;
    },
    selectThisDay: function selectThisDay(day, jsEvent) {
      var _this2 = this;

      var currentDay = __WEBPACK_IMPORTED_MODULE_1__dateFunc___default.a.format(day.date, this.formatDate);
      if (day.weekDay > this.fridayNumber || !day.isCurMonth) {
        return false;
      }

      if (this.isHolidaysCalendar && !day.isFutureDate && day.events.length === 0) {
        return false;
      }

      this.holidayName = '';
      if (day.events.length) {
        day.events.filter(function (e) {
          if (e.cssClass === _this2.classPublic) {
            _this2.morePos = _this2.computePos(jsEvent.target);
            _this2.cancelHolidays(_this2.isHolidaysCalendar);
            _this2.cancelRemove();
            _this2.selectDay = _this2.getSelectDay;
            _this2.holidayName = e.name;
            if (!_this2.isHolidaysCalendar) {
              _this2.setEditingId(e.start);
            } else {
              _this2.showOnly = true;
            }
          }
          if (e.cssClass === _this2.classHoliday) {
            _this2.cancelHolidays(_this2.isHolidaysCalendar);
            _this2.cancelRemove();
            _this2.setEditingId(e.id);
            _this2.selectDay = _this2.getSelectDay;
            _this2.workingDays = e.workingDays;
            _this2.morePos = _this2.computePos(jsEvent.target);
          }
        });

        if (!this.getShowMore) {
          this.showMore = true;
        }

        if (this.showMore && !this.getStartDate) {
          this.setShowMore(this.title);
          this.morePos = this.computePos(jsEvent.target);
        }

        this.setStartDate(day.events[0].start);
        this.setEndDate(day.events[0].end);
      } else {
        if (day.newVacations.length) {
          day.events.filter(function (e) {
            if (e.cssClass === _this2.classPublic) {
              return false;
            }
          });

          this.selectDay = this.getSelectDay;
          if (this.selectDay[0] !== currentDay) {
            this.setSelectDay([day.newVacations[0].start, __WEBPACK_IMPORTED_MODULE_1__dateFunc___default.a.format(currentDay, this.formatDate)]);

            this.setStartDate(__WEBPACK_IMPORTED_MODULE_1__dateFunc___default.a.format(day.newVacations[0].start, this.formatDate));
            this.setEndDate(__WEBPACK_IMPORTED_MODULE_1__dateFunc___default.a.format(currentDay, this.formatDate));
            this.updateEvents(this.isHolidaysCalendar);
          } else {
            this.setStartDate(__WEBPACK_IMPORTED_MODULE_1__dateFunc___default.a.format(day.newVacations[0].start, this.formatDate));
            this.setEndDate(__WEBPACK_IMPORTED_MODULE_1__dateFunc___default.a.format(day.newVacations[0].end, this.formatDate));
          }
        } else {
          if (this.isHolidaysCalendar) {
            if (this.getEndDate === this.getStartDate && !day.newVacations) {
              this.cancelHolidays(this.isHolidaysCalendar);
              this.cancelRemove();
              this.selectDay = this.getSelectDay;
              this.morePos = this.computePos(jsEvent.target);
            }
            if (!this.selectDay.length && this.getEditingId) {
              this.cancelHolidays(this.isHolidaysCalendar);
              this.cancelRemove();
              this.selectDay = this.getSelectDay;
            } else if (!this.selectDay.length && !this.getEditingId) {
              this.morePos = this.computePos(jsEvent.target);
            } else if (this.selectDay.length && this.getEditingId) {
              this.cancelHolidays(this.isHolidaysCalendar);
              this.cancelRemove();
              this.selectDay = this.getSelectDay;
              this.setShowMore(this.title);
              this.morePos = this.computePos(jsEvent.target);
            }

            if (!this.getStartDate) {
              this.cancelHolidays(this.isHolidaysCalendar);
              this.cancelRemove();
              this.selectDay = this.getSelectDay;
              this.setShowMore(this.title);
              this.morePos = this.computePos(jsEvent.target);
            }

            if (this.getMe.remainingDays > 0 || this.getStartDate === '') {
              this.selectDay = this.getSelectDay;
              this.selectDay.push(currentDay);

              var orderDates = this.selectDay.sort(function (a, b) {
                return new Date('"' + a + '"') - new Date('"' + b + '"');
              });

              var min = orderDates[0];
              var max = orderDates[orderDates.length - 1];

              this.setSelectDay([min, max]);

              this.setStartDate(this.getSelectDay[0]);
              this.setEndDate(this.getSelectDay[this.getSelectDay.length - 1]);
            } else if (this.getStartDate !== '') {
              if (this.getEndDate === this.getStartDate) {
                this.morePos = this.computePos(jsEvent.target);
              }
            }
          } else {
            this.cancelHolidays(this.isHolidaysCalendar);
            this.cancelRemove();
            this.selectDay = this.getSelectDay;
            this.setShowMore(this.title);
            this.morePos = this.computePos(jsEvent.target);
            this.setStartDate(currentDay);
          }

          this.updateEvents(this.isHolidaysCalendar);
        }
      }
    },
    computePos: function computePos(target) {
      var eventRect = target.getBoundingClientRect();
      var pageRect = this.$refs.dates.getBoundingClientRect();

      var left = eventRect.left - pageRect.left;
      var top = eventRect.top - pageRect.top;

      if (eventRect.left < 150) {
        left = 125;
        this.boxLeft = true;
      } else {
        this.boxLeft = false;
      }

      if (pageRect.top < 150) {
        top += 150 + eventRect.height;
        this.boxTop = true;
      } else {
        this.boxTop = false;
      }

      return {
        left: left,
        top: top
      };
    },
    dispatchEvent: function dispatchEvent() {
      this.title = __WEBPACK_IMPORTED_MODULE_1__dateFunc___default.a.format(this.headDate, this.titleFormat, this.monthNames);
      var m = new Date(this.currentDate);
      this.month = m.getMonth() + 1;
    }
  })
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(29);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Navbar',
  data: function data() {
    return {
      showOptions: false
    };
  },
  props: {
    admin: Boolean
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getMe', 'isAdmin'])),
  mounted: function mounted() {
    document.addEventListener('click', this.onClick);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.onClick);
  },

  methods: {
    onClick: function onClick(ev) {
      if (!this.$el.contains(ev.target)) {
        this.showOptions = false;
      }
    },
    logout: function logout() {
      return window.fetch(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.config.holidays.LOGOUT).then(function (response) {
        if (response.status === 200) {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'login' });
        }
      }).catch(function () {
        return __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: '404' });
      });
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OnHolidaysPopup',
  data: function data() {
    return {
      date1: '01/05/2017',
      kaleidersList: [{
        'picture': 'https://plus.google.com/u/1/_/focus/photos/public/' + 'AIbEiAIAAABECIuzu8Wc-u-jtgEiC3ZjYXJkX3Bob3RvKig3MzhkNTU3OGY' + '4OTcyZGVhNzg5MzRiZTVlNGZkMzI5NjcyY2VkZjhjMAEGq2OE5d_GfC5SSQ' + 'eGYwIx29zrFg?sz=24',
        'name': 'Andres Gonzalez'
      }, {
        'picture': 'https://plus.google.com/u/1/_/focus/photos/public/' + 'AIbEiAIAAABDCIfSu6TTlY7rSiILdmNhcmRfcGhvdG8qKDMyMjJkZjYyYTU' + 'zMGRjOGUwYmExNzQwOTIyMjBiNjU1MGZlZjNlOTkwAVSMcokS8uWp0XdN8E' + 'k3q9mkq2ki?sz=24',
        'name': 'Pablo Alba'
      }, {
        'picture': 'https://plus.google.com/u/1/_/focus/photos/private/' + 'AIbEiAIAAABECMze_bqEtPjtxwEiC3ZjYXJkX3Bob3RvKig4NjZiNjk4MjJ' + 'mZTA1ZWNhZWE1YzJhNDIzNWI5NDNhOGExNTI5YTRkMAHXJiJoMKGdYm3opj' + 'lH-D5cza-78g?sz=24',
        'name': 'María Cano'
      }, {
        'picture': 'https://plus.google.com/u/1/_/focus/photos/public/' + 'AIbEiAIAAABDCJ-yne2G08HtcSILdmNhcmRfcGhvdG8qKDNlYzE1NTQzZmE' + 'xNjhiOTFmYWRhZWFlY2FjYWNhNjIyMDg4MGNlYzEwAaCYL3WRCGFv-LCY5b' + 'YResDi7f8N?sz=24',
        'name': 'Yamila Moreno'
      }]
    };
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuCalendar_MenuCalendar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuCalendar_MenuCalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MenuCalendar_MenuCalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Month_Month__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Month_Month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Month_Month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PublicHolidays',
  components: {
    Month: __WEBPACK_IMPORTED_MODULE_3__Month_Month___default.a,
    MenuCalendar: __WEBPACK_IMPORTED_MODULE_2__MenuCalendar_MenuCalendar___default.a
  },
  data: function data() {
    return {
      totalMonths: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.config.holidays.TOTAL_MONTHS,
      currentYear: 2017,
      yearList: [2017, 2016, 2015, 2014],
      PUBLIC_HOLIDAY: 'Public holiday',
      isHolidaysCalendar: false
    };
  },
  created: function created() {
    this.holidays();
    this.cancelHolidays(this.isHolidaysCalendar);
  },

  watch: {
    getSelectedYear: function getSelectedYear() {
      this.holidays();
    },
    getUpdateHolidays: function getUpdateHolidays(val) {
      this.holidays();
      this.setUpdateHolidays(false);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['holidays', 'cancelHolidays', 'setUpdateHolidays']), {
    setMonth: function setMonth(n) {
      var year = this.getSelectedYear;
      var everyMonth = new Date(year, n - 1);
      return everyMonth;
    },
    changeYear: function changeYear(year) {
      this.currentYear = year;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getHolidays', 'getSelectedYear', 'getUpdateHolidays']), {
    events: function events() {
      var currentHolidays = [];
      if (this.getHolidays.length) {
        currentHolidays = this.getHolidays.map(function (holidays) {
          var PUBLIC_CLASS = 'public';
          return {
            start: holidays.date,
            end: holidays.date,
            name: holidays.name,
            cssClass: PUBLIC_CLASS
          };
        });
      }
      return currentHolidays;
    }
  })
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar_Calendar__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar_Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Calendar_Calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuCalendar_MenuCalendar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuCalendar_MenuCalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MenuCalendar_MenuCalendar__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Wrapper',
  components: {
    Calendar: __WEBPACK_IMPORTED_MODULE_0__Calendar_Calendar___default.a,
    MenuCalendar: __WEBPACK_IMPORTED_MODULE_1__MenuCalendar_MenuCalendar___default.a
  },
  data: function data() {
    return {
      isHolidaysCalendar: true
    };
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar_Navbar__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navbar_Navbar__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Admin',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__components_Navbar_Navbar___default.a
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar_Navbar__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navbar_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Wrapper_Wrapper__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Wrapper_Wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Wrapper_Wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BookHolidayPopup_BookHolidayPopup__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BookHolidayPopup_BookHolidayPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_BookHolidayPopup_BookHolidayPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_OnHolidaysPopup_OnHolidaysPopup__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_OnHolidaysPopup_OnHolidaysPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_OnHolidaysPopup_OnHolidaysPopup__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__components_Navbar_Navbar___default.a,
    Wrapper: __WEBPACK_IMPORTED_MODULE_1__components_Wrapper_Wrapper___default.a,
    BookHolidayPopup: __WEBPACK_IMPORTED_MODULE_2__components_BookHolidayPopup_BookHolidayPopup___default.a,
    OnHolidaysPopup: __WEBPACK_IMPORTED_MODULE_3__components_OnHolidaysPopup_OnHolidaysPopup___default.a
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GoogleBtn_GoogleBtn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GoogleBtn_GoogleBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_GoogleBtn_GoogleBtn__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  components: {
    GoogleBtn: __WEBPACK_IMPORTED_MODULE_0__components_GoogleBtn_GoogleBtn___default.a
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GoogleBtn_GoogleBtn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GoogleBtn_GoogleBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_GoogleBtn_GoogleBtn__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LoginKo',
  components: {
    GoogleBtn: __WEBPACK_IMPORTED_MODULE_0__components_GoogleBtn_GoogleBtn___default.a
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(145)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(191),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(146)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(192),
  /* scopeId */
  "data-v-e1971dbe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(133)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(179),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(144)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(190),
  /* scopeId */
  "data-v-9aa9843a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(141)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(187),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(132)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(178),
  /* scopeId */
  "data-v-12fb91af",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(137)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(183),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(181),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(136)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(182),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Home"
  }, [_c('Navbar'), _c('Wrapper')], 1)
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "public",
    attrs: {
      "id": "Wrapper"
    }
  }, [_c('MenuCalendar', {
    attrs: {
      "showBookedHolidays": _vm.isHolidaysCalendar
    }
  }), _c('div', {
    staticClass: "comp-full-calendar"
  }, _vm._l((_vm.totalMonths), function(n) {
    return _c('Month', {
      key: n,
      attrs: {
        "current-date": _vm.setMonth(n),
        "events": _vm.events,
        "isHolidaysCalendar": _vm.isHolidaysCalendar
      }
    })
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-ko"
  }, [_c('div', {
    staticClass: "login-content"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 0.052916666 0.052915319"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 0.03622571,4.1085091e-4 C 0.03590929,-3.4449085e-5 0.03542293,6.5091458e-7 0.03542293,6.5091458e-7 H 0.01766784 c 0,0 -4.9808e-4,-3.509999958e-5 -8.2037e-4,4.2189999542e-4 -3.1642e-4,4.571e-4 -1.2891e-4,9.0829909e-4 -1.2891e-4,9.0829909e-4 l 0.0040139,0.00998 c 0,0 7.031e-5,1.583e-4 2.0509e-4,2.93e-4 1.2891e-4,1.524e-4 2.8127e-4,2.461e-4 2.8127e-4,2.461e-4 l 0.0049222,0.0025 c 0,0 1.6407e-4,7.62e-5 3.8088e-4,8.2e-5 2.2268e-4,0 4.4535e-4,-9.96e-5 4.4535e-4,-9.96e-5 l 0.0048988,-0.00247 c 0,0 1.5821e-4,-8.2e-5 2.9299e-4,-2.344e-4 1.4649e-4,-1.582e-4 1.9923e-4,-3.106e-4 1.9923e-4,-3.106e-4 l 0.0039964,-0.00998 c 0,0 1.9337e-4,-4.6879909e-4 -1.2892e-4,-9.1999909e-4 z",
      "fill": "#304392"
    }
  }), _c('path', {
    attrs: {
      "d": "m 0.01486101,0.00110235 c -5.5081e-4,-1.0549909e-4 -8.5552e-4,2.754e-4 -8.5552e-4,2.754e-4 l -0.01256333,0.012552 c 0,0 -3.8089e-4,3.281e-4 -2.8127e-4,8.79e-4 8.789e-5,5.449e-4 5.391e-4,7.383e-4 5.391e-4,7.383e-4 l 0.009903,0.00422 c 0,0 1.5821e-4,5.86e-5 3.5158e-4,5.86e-5 1.9337e-4,1.76e-5 3.7503e-4,-2.34e-5 3.7503e-4,-2.34e-5 l 0.0052503,-0.00172 c 0,0 1.6408e-4,-5.86e-5 3.2229e-4,-2.109e-4 1.5822e-4,-1.524e-4 2.4611e-4,-3.809e-4 2.4611e-4,-3.809e-4 l 0.001711,-0.00522 c 0,0 4.688e-5,-1.641e-4 3.516e-5,-3.75e-4 0,-2.051e-4 -7.618e-5,-3.516e-4 -7.618e-5,-3.516e-4 l -0.0042132,-0.00988 c 0,0 -1.9337e-4,-4.746e-4 -7.4419e-4,-5.625e-4 z",
      "fill": "#b4d35f"
    }
  }), _c('path', {
    attrs: {
      "d": "M 4.1083724e-4,0.01675965 C -3.4504814e-5,0.01709365 6.5377566e-7,0.01757995 6.5377566e-7,0.01757995 v 0.017755 c 0,0 -3.515858966e-5,5.04e-4 4.2190299434e-4,8.204e-4 4.5706158e-4,3.223e-4 9.0826323e-4,1.348e-4 9.0826323e-4,1.348e-4 l 0.00998504,-0.00401 c 0,0 1.5821e-4,-7.62e-5 2.9299e-4,-2.051e-4 1.5235e-4,-1.172e-4 2.4611e-4,-2.813e-4 2.4611e-4,-2.813e-4 l 0.0024963,-0.00492 c 0,0 7.617e-5,-1.582e-4 8.203e-5,-3.75e-4 0,-2.168e-4 -9.961e-5,-4.453e-4 -9.961e-5,-4.453e-4 l -0.0024728,-0.00489 c 0,0 -8.204e-5,-1.582e-4 -2.344e-4,-2.93e-4 -1.5821e-4,-1.523e-4 -3.1056e-4,-2.051e-4 -3.1056e-4,-2.051e-4 l -0.00997918,-0.00403 c 0,0 -4.6878118e-4,-1.993e-4 -9.1998299e-4,1.172e-4 z m 0.0520933028,0 c 4.6878e-4,3.281e-4 4.1018e-4,8.086e-4 4.1018e-4,8.086e-4 v 0.017755 c 0,0 4.102e-5,5.039e-4 -4.1018e-4,8.204e-4 -4.5706e-4,3.223e-4 -9.1413e-4,1.347e-4 -9.1413e-4,1.347e-4 l -0.009985,-0.00401 c 0,0 -1.5236e-4,-7.62e-5 -2.9299e-4,-2.051e-4 -1.465e-4,-1.172e-4 -2.3439e-4,-2.813e-4 -2.3439e-4,-2.813e-4 l -0.0025021,-0.00492 c 0,0 -7.618e-5,-1.582e-4 -8.204e-5,-3.75e-4 0,-2.168e-4 9.376e-5,-4.454e-4 9.376e-5,-4.454e-4 l 0.0024728,-0.00489 c 0,0 8.204e-5,-1.582e-4 2.3439e-4,-2.93e-4 1.5821e-4,-1.524e-4 3.1057e-4,-2.051e-4 3.1057e-4,-2.051e-4 l 0.0099792,-0.00401 c 0,0 4.6879e-4,-1.992e-4 9.1999e-4,1.172e-4 z",
      "fill": "#a9305e"
    }
  }), _c('path', {
    attrs: {
      "d": "m 0.03622571,0.05250415 c -3.1642e-4,4.512e-4 -8.0278e-4,4.102e-4 -8.0278e-4,4.102e-4 H 0.01766784 c 0,0 -4.9808e-4,3.52e-5 -8.2037e-4,-4.219e-4 -3.1642e-4,-4.571e-4 -1.2891e-4,-9.141e-4 -1.2891e-4,-9.141e-4 l 0.0040139,-0.00997 c 0,0 7.031e-5,-1.582e-4 2.0509e-4,-3.047e-4 1.2891e-4,-1.465e-4 2.8127e-4,-2.344e-4 2.8127e-4,-2.344e-4 l 0.0049222,-0.0025 c 0,0 1.6407e-4,-7.62e-5 3.8088e-4,-8.2e-5 2.2268e-4,0 4.4535e-4,9.37e-5 4.4535e-4,9.37e-5 l 0.0048988,0.00247 c 0,0 1.5821e-4,8.21e-5 2.9299e-4,2.344e-4 1.4649e-4,1.641e-4 1.9923e-4,3.106e-4 1.9923e-4,3.106e-4 l 0.0039964,0.00997 c 0,0 1.9337e-4,4.57e-4 -1.2892e-4,9.199e-4 z",
      "fill": "#304392"
    }
  }), _c('path', {
    attrs: {
      "d": "m 0.01486101,0.05185965 c -5.5081e-4,9.37e-5 -8.6138e-4,-2.755e-4 -8.6138e-4,-2.755e-4 L 0.00144216,0.03902675 c 0,0 -3.7503e-4,-3.282e-4 -2.6955e-4,-8.79e-4 8.789e-5,-5.45e-4 5.3909e-4,-7.325e-4 5.3909e-4,-7.325e-4 l 0.00990301,-0.00422 c 0,0 1.5821e-4,-5.86e-5 3.5158e-4,-7.03e-5 1.9337e-4,0 3.7503e-4,3.51e-5 3.7503e-4,3.51e-5 l 0.0052386,0.00171 c 0,0 1.6408e-4,5.86e-5 3.2229e-4,2.11e-4 1.5822e-4,1.465e-4 2.4611e-4,3.75e-4 2.4611e-4,3.75e-4 l 0.001711,0.00522 c 0,0 4.688e-5,1.641e-4 3.516e-5,3.75e-4 0,2.11e-4 -7.618e-5,3.516e-4 -7.618e-5,3.516e-4 l -0.004219,0.00989 c 0,0 -1.8751e-4,4.688e-4 -7.4419e-4,5.625e-4 z m 0.02325741,-0.050757 c 5.5081e-4,-9.96e-5 8.6138e-4,2.754e-4 8.6138e-4,2.754e-4 l 0.01255748,0.012552 c 0,0 3.7502e-4,3.281e-4 2.8126e-4,8.79e-4 -9.961e-5,5.449e-4 -5.5081e-4,7.383e-4 -5.5081e-4,7.383e-4 l -0.009903,0.00422 c 0,0 -1.5822e-4,5.86e-5 -3.5159e-4,5.86e-5 -1.9923e-4,1.76e-5 -3.7502e-4,-2.34e-5 -3.7502e-4,-2.34e-5 l -0.0052386,-0.00172 c 0,0 -1.758e-4,-5.86e-5 -3.2815e-4,-2.109e-4 -1.5821e-4,-1.524e-4 -2.4611e-4,-3.809e-4 -2.4611e-4,-3.809e-4 l -0.0016993,-0.00522 c 0,0 -5.86e-5,-1.641e-4 -5.86e-5,-3.75e-4 1.758e-5,-2.051e-4 8.204e-5,-3.516e-4 8.204e-5,-3.516e-4 l 0.004219,-0.00989 c 0,0 1.9337e-4,-4.688e-4 7.4419e-4,-5.567e-4 z",
      "fill": "#de5d4a"
    }
  }), _c('path', {
    attrs: {
      "d": "m 0.03811842,0.05185965 c 5.5081e-4,9.37e-5 8.6138e-4,-2.755e-4 8.6138e-4,-2.755e-4 l 0.01255748,-0.012557 c 0,0 3.7502e-4,-3.282e-4 2.8126e-4,-8.79e-4 -9.961e-5,-5.45e-4 -5.5081e-4,-7.325e-4 -5.5081e-4,-7.325e-4 l -0.009903,-0.00422 c 0,0 -1.5822e-4,-5.86e-5 -3.5159e-4,-7.03e-5 -1.9923e-4,0 -3.7502e-4,3.51e-5 -3.7502e-4,3.51e-5 l -0.0052386,0.00171 c 0,0 -1.758e-4,5.86e-5 -3.2815e-4,2.109e-4 -1.5821e-4,1.465e-4 -2.4611e-4,3.751e-4 -2.4611e-4,3.751e-4 l -0.0016993,0.00522 c 0,0 -5.86e-5,1.64e-4 -5.86e-5,3.75e-4 1.758e-5,2.109e-4 8.204e-5,3.516e-4 8.204e-5,3.516e-4 l 0.004219,0.00989 c 0,0 1.9337e-4,4.687e-4 7.4419e-4,5.625e-4 z",
      "fill": "#b4d35f"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("D´oh!")]), _c('p', [_vm._v("You must sign in with a Kaleidos mail account")]), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: "login"
      }
    }
  }, [_vm._v("Retry to sign in")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('div', {
    staticClass: "illustration"
  }, [_c('svg', {
    attrs: {
      "xmlns:dc": "http://purl.org/dc/elements/1.1/",
      "xmlns:cc": "http://creativecommons.org/ns#",
      "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
      "xmlns:svg": "http://www.w3.org/2000/svg",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
      "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
      "viewBox": "0 0 585.00001 226.99999",
      "id": "svg8623",
      "version": "1.1",
      "inkscape:version": "0.91 r13725",
      "sodipodi:docname": "racoon.svg"
    }
  }, [_c('defs', {
    attrs: {
      "id": "defs8625"
    }
  }), _vm._v(" "), _c('sodipodi:namedview', {
    attrs: {
      "id": "base",
      "pagecolor": "#ffffff",
      "bordercolor": "#666666",
      "borderopacity": "1.0",
      "inkscape:pageopacity": "0.0",
      "inkscape:pageshadow": "2",
      "inkscape:zoom": "1.4",
      "inkscape:cx": "290.22418",
      "inkscape:cy": "112.16687",
      "inkscape:document-units": "px",
      "inkscape:current-layer": "layer1",
      "showgrid": "false",
      "units": "px",
      "inkscape:window-width": "1487",
      "inkscape:window-height": "647",
      "inkscape:window-x": "2348",
      "inkscape:window-y": "300",
      "inkscape:window-maximized": "0"
    }
  }), _vm._v(" "), _c('metadata', {
    attrs: {
      "id": "metadata8628"
    }
  }, [_c('rdf:RDF', [_c('cc:Work', {
    attrs: {
      "rdf:about": ""
    }
  }, [_c('dc:format', [_vm._v("image/svg+xml")]), _vm._v(" "), _c('dc:type', {
    attrs: {
      "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
    }
  }), _vm._v(" "), _c('dc:title')], 1)], 1)], 1), _vm._v(" "), _c('g', {
    attrs: {
      "inkscape:label": "Layer 1",
      "inkscape:groupmode": "layer",
      "id": "layer1",
      "transform": "translate(0,-825.3623)"
    }
  }, [_c('g', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "transform": "translate(858.21623,-7891.7997)",
      "id": "g307771",
      "inkscape:export-filename": "/home/andy/Desktop/racoon.svg",
      "inkscape:export-xdpi": "90",
      "inkscape:export-ydpi": "90"
    }
  }, [_c('g', {
    staticStyle: {
      "display": "inline",
      "stroke": "#859cad",
      "stroke-opacity": "1"
    },
    attrs: {
      "id": "g24120-4",
      "transform": "translate(-1406.8318,8605.9293)"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24122-8",
      "d": "m 828.72915,279.9943 c 0,-0.61872 -6.18718,-9.45756 -12.99309,-15.9983 -6.8059,-6.54073 -15.82151,-9.8111 -15.82151,-9.8111 0,0 -0.0884,2.20971 0.97227,3.53553 1.06066,1.32583 2.2981,2.20971 2.2981,2.20971 0,0 -3.62392,-2.47487 -7.42462,-3.53553 -3.8007,-1.06066 -8.30851,-4.5962 -8.30851,-4.5962 0,0 1.85616,9.45756 3.88909,12.10921 2.03293,2.65165 5.03814,3.97747 5.03814,3.97747 0,0 -4.41942,-0.88388 -6.18719,-0.88388 -1.76777,0 -3.53553,0.79549 -3.53553,0.79549 0,0 4.06586,3.27037 4.77297,5.21492 0.7071,1.94454 3.18198,14.58407 7.33623,21.38998 4.15425,6.8059 21.65515,12.55114 21.65515,12.55114 z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#859cad",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1px",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24124-1",
      "d": "m 792.84348,277.51942 15.37957,-19.44543 3.53554,2.38648 -17.14734,22.27386 z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#859cad",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1px",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24126-2",
      "d": "m 797.17451,289.45185 19.18027,-24.57196 3.53554,3.27037 -20.59449,26.69328 -2.74004,-4.33103 z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#859cad",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1px",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24128-9",
      "d": "m 804.24558,299.52812 20.15254,-26.95845 3.18198,4.24265 -18.29639,25.63262 z"
    }
  })]), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "2",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -729.2693,8791.8431 c 0,0 10.75,-2.1875 18.75,-2.3125 8,-0.125 19.5,1.1875 28.6875,24.9375 9.1875,23.75 1.8232,68.1419 6,97.125 1.9742,13.6991 6.5,24.75 19.75,29.75 13.25,5 20.75,-2.75 20.75,-6.5 0,-3.75 -7.75,-10.25 -14.75,-8.25 -7,2 -0.25,7 5,7.75 5.25,0.75 18.9071,2.4899 27.5,-7.5 11.6462,-13.5395 8.341,-24.659 11.75,-31 3.2657,-6.0744 6.5,-5.5 6.5,-5.5",
      "id": "path24130-3",
      "inkscape:connector-curvature": "0",
      "sodipodi:nodetypes": "csssssssssc"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "#ffffff",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -584.9969,8900.3309 c -0.3536,0.088 -2.1214,-4.1543 -5.4801,-2.5633 -3.3588,1.591 -4.5962,8.0434 -2.0329,14.6725 2.5632,6.6291 5.2149,9.1924 5.2149,9.1924 0,0 -5.6569,-2.2097 -9.3692,-2.1213 -3.7123,0.088 -5.3917,3.2703 -5.3033,4.5962 0.088,1.3258 1.8562,2.8284 1.8562,2.8284 l 20.2409,0 -0.5303,-6.2756 z",
      "id": "path24132-9",
      "inkscape:connector-curvature": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "#ffffff",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24134-0",
      "d": "m -549.8401,8900.3309 c 0.3536,0.088 2.1214,-4.1543 5.4801,-2.5633 3.3588,1.591 4.5962,8.0434 2.0329,14.6725 -2.5632,6.6291 -5.2149,9.1924 -5.2149,9.1924 0,0 5.6569,-2.2097 9.3692,-2.1213 3.7123,0.088 5.3917,3.2703 5.3033,4.5962 -0.088,1.3258 -1.8562,2.8284 -1.8562,2.8284 l -20.2409,0 0.5303,-6.2756 z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "2",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -454.0515,8911.8431 c 0,0 -6.2803,2.75 -11.2803,12.75 -5,10 -19.25,17.75 -35,16.5 -15.75,-1.25 -19,-19.5 -21.25,-32 -2.25,-12.5 -11.5607,-19.8813 -11.5607,-19.8813",
      "id": "path24136-8",
      "inkscape:connector-curvature": "0",
      "sodipodi:nodetypes": "csssc"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "#ffffff",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -581.6384,8863.3844 -2.3868,1.414 0.016,0.1426 -0.072,-0.2226 c 0,0 0.088,0.4938 0.1719,1.0937 l 0.072,0.6309 c 0.2736,2.5196 0.4022,7.2578 -1.9941,10.2754 -3.375,4.25 -5.5,4.25 -9.875,5.875 -4.375,1.625 -4.75,5.75 -3.75,8.75 1,3 4,4.75 5.875,3.625 1.875,-1.125 1.25,-6.125 1.25,-6.125 0,0 5.75,0.375 8.625,-2.875 0.716,-0.8094 1.2999,-1.5666 1.8359,-2.2969 l 0.066,0.5957 c -1.3242,3.3286 -4.1036,11.4258 -3.9004,20.5723 0.2652,11.9324 5.3049,19.8867 17.4141,19.8867 12.9949,0 18.2954,-6.2751 18.9141,-18.8262 0.5369,-10.8921 -0.7921,-18.8602 -1.17,-20.8809 l 0.1094,-0.4218 0.037,-0.4336 c 0.4524,0.5863 0.9378,1.189 1.4824,1.8047 2.875,3.25 8.625,2.875 8.625,2.875 0,0 -0.625,5 1.25,6.125 1.875,1.125 4.875,-0.625 5.875,-3.625 1,-3 0.625,-7.125 -3.75,-8.75 -4.375,-1.625 -6.5,-1.625 -9.875,-5.875 -3.375,-4.25 -1.75,-12 -1.75,-12 l -0.2285,0.6992 -32.8672,-2.0332 z",
      "id": "path24138-8",
      "inkscape:connector-curvature": "0"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "id": "rect24170-5",
      "width": "159.45258",
      "height": "6.3639612",
      "x": "-857.05627",
      "y": "8809.6445"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "y": "8919.6445",
      "x": "-833.18127",
      "height": "6.3639612",
      "width": "111.70258",
      "id": "rect24172-0"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "id": "rect24174-9",
      "width": "20.952583",
      "height": "103.6495",
      "x": "-762.43127",
      "y": "8816.0459"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "y": "8765.3477",
      "x": "-735.89471",
      "height": "31.289476",
      "width": "6.5040913",
      "id": "rect24176-6"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "id": "circle24178-3",
      "cx": "-737.70679",
      "cy": "8758.8428",
      "r": "10.3125"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "y": "-1501.6694",
      "x": "8620.1592",
      "height": "3.8639612",
      "width": "75.702576",
      "id": "rect24180-8",
      "transform": "matrix(-0.25369727,0.96728367,-0.96728367,-0.25369727,0,0)"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "y": "8803.168",
      "x": "-750.7439",
      "height": "6.3639612",
      "width": "36.202576",
      "id": "rect24182-5"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "id": "rect24184-6",
      "width": "20.823004",
      "height": "6.3639612",
      "x": "-743.0542",
      "y": "8796.7256"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "r": "4.6556458",
      "cy": "8758.8428",
      "cx": "-737.70679",
      "id": "circle24186-1"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "d": "m -824.5385,8800.9933 0.8348,3.708 3.3631,-0.7572 -0.8348,-3.708 -3.3631,0.7572 z m 5.8535,-1.3179 0.8348,3.708 3.3631,-0.7572 -0.8348,-3.7079 -3.3631,0.7571 z m 5.8534,-1.3178 0.8349,3.7079 3.3631,-0.7571 -0.8349,-3.708 -3.3631,0.7572 z m 5.8535,-1.3179 0.8348,3.708 3.3631,-0.7572 -0.8348,-3.708 -3.3631,0.7572 z m 9.7558,-2.1964 0.8348,3.7079 3.3631,-0.7571 -0.8348,-3.708 -3.3631,0.7572 z m -28.7903,10.558 0.8348,3.708 35.3553,-7.96 -0.8348,-3.708 -35.3553,7.96 z",
      "id": "path24188-1",
      "inkscape:connector-curvature": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "#ffffff",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -801.9568,8809.4681 c 0,0 2.5,-8.5625 11.875,-8.5 9.375,0.062 11.9375,8.625 11.9375,8.625 z",
      "id": "path24190-5",
      "inkscape:connector-curvature": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -786.2068,8809.4681 2.1875,-6.875",
      "id": "path24192-9",
      "inkscape:connector-curvature": "0"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "y": "8742.0215",
      "x": "-454.4314",
      "height": "185.67389",
      "width": "109.34093",
      "id": "rect24194-8"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "id": "rect24196-4",
      "width": "95.552345",
      "height": "167.76283",
      "x": "-447.53711",
      "y": "8750.9775"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "id": "rect24198-8",
      "width": "86.974136",
      "height": "52.679455",
      "x": "-443.39893",
      "y": "8766.1572"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "y": "8837.0518",
      "x": "-443.39893",
      "height": "2.8284268",
      "width": "27.577168",
      "id": "rect24200-1"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "id": "rect24202-0",
      "width": "27.577168",
      "height": "2.8284268",
      "x": "-443.39893",
      "y": "8857.0518"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "y": "8877.0518",
      "x": "-443.39893",
      "height": "2.8284268",
      "width": "27.577168",
      "id": "rect24204-3"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "id": "rect24206-0",
      "width": "27.577168",
      "height": "2.8284268",
      "x": "-443.39893",
      "y": "8897.0518"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "id": "rect24208-4",
      "width": "2.4748769",
      "height": "2.8284268",
      "x": "-360.29657",
      "y": "8837.0518"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "y": "8857.0518",
      "x": "-360.29657",
      "height": "2.8284268",
      "width": "2.4748769",
      "id": "rect24210-4"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "id": "rect24212-4",
      "width": "2.4748769",
      "height": "2.8284268",
      "x": "-360.29657",
      "y": "8877.0518"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "y": "8897.0518",
      "x": "-360.29657",
      "height": "2.8284268",
      "width": "2.4748769",
      "id": "rect24214-4"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "y": "8837.0518",
      "x": "-368.29657",
      "height": "2.8284268",
      "width": "2.4748769",
      "id": "rect24216-7"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "id": "rect24218-6",
      "width": "2.4748769",
      "height": "2.8284268",
      "x": "-368.29657",
      "y": "8857.0518"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "y": "8877.0518",
      "x": "-368.29657",
      "height": "2.8284268",
      "width": "2.4748769",
      "id": "rect24220-3"
    }
  }), _vm._v(" "), _c('rect', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "id": "rect24222-1",
      "width": "2.4748769",
      "height": "2.8284268",
      "x": "-368.29657",
      "y": "8897.0518"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -444.1489,8848.5353 87.0171,0",
      "id": "path24224-7",
      "inkscape:connector-curvature": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24226-5",
      "d": "m -444.1489,8868.5353 87.0171,0"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -444.1489,8888.5353 87.0171,0",
      "id": "path24228-9",
      "inkscape:connector-curvature": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24230-6",
      "d": "m -444.1489,8908.5353 87.0171,0"
    }
  }), _vm._v(" "), _c('g', {
    staticStyle: {
      "display": "inline",
      "stroke": "#859cad",
      "stroke-opacity": "1"
    },
    attrs: {
      "id": "g24232-2",
      "transform": "translate(-1408.8318,8609.9293)"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24234-1",
      "d": "m 842.625,262.91382 c 0,0 -4.25,-0.5 -6.875,-2.25 -2.625,-1.75 -7,-0.5 -11,-1.375 -4,-0.875 -11.625,-7.375 -11.625,-7.375 l 2.875,-1.25 c 0,0 -5.125,-2.25 -3.875,-2.25 1.25,0 3.375,-0.75 4.625,-1.875 1.25,-1.125 0.875,-5.125 0.875,-5.125 l 2,-3.125 -1,-1.125 3.5,-4 -3,-4.625 3.875,0.875 c 0,0 -2.25,-12.375 0.75,-17.5 3,-5.125 14.375,7.375 14.375,7.375 l 6.625,-1.25 -0.5,2.75 c 0,0 6,-2.125 8.25,-3.875 2.25,-1.75 10,-7.875 11.625,-7.125 1.625,0.75 3.125,12.25 2,16.125 -1.125,3.875 -0.75,4.625 -0.75,4.625 l 4,7.25 -3.75,-1.875 6.875,15 -2.5,-0.5 3.125,4.875 -5.25,0.375 c 0,0 3.75,2.5 3.25,2.5 -0.5,0 -11.625,2.125 -14.25,1.625 -2.625,-0.5 -9.25,2.75 -14.25,3.125 z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#859cad",
      "fill-opacity": "1",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1px",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24236-7",
      "d": "m 844.32289,234.44683 -2.36414,7.00758 c 0,0 -3.55877,-4.21298 -5.93636,-4.27038 -2.3776,-0.0574 -14.32881,6.22256 -14.32881,6.22256 l 1.7757,3.07574 -4.17007,2.86977 c 0,0 2.47511,5.6819 6.63755,6.93902 4.16244,1.25712 11.10247,1.24722 11.10247,1.24722 l 15.05285,-0.55336 c 0,0 5.35657,1.47324 7.88248,0.15086 2.52591,-1.32238 8.01531,-6.16797 8.01531,-6.16797 l -4.79963,-1.67666 2.81517,-2.14344 c 0,0 -10.14654,-9.40271 -13.3523,-9.99927 -3.20577,-0.59657 -6.15148,3.5514 -6.15148,3.5514 z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24238-8",
      "d": "m 823.42585,229.61294 3.88909,-1.32583 0,-3.8007 3.0052,0.61872 -1.5026,-4.06586 c 0,0 2.56326,0.35355 2.47487,0 -0.0884,-0.35356 -0.0884,-5.56847 -2.74004,-6.71752 -2.65165,-1.14905 -3.0052,5.12653 -3.0052,5.12653"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m 865.09845,229.61294 -3.88909,-1.32583 0,-3.8007 -3.0052,0.61872 1.5026,-4.06586 c 0,0 -2.56326,0.35355 -2.47487,0 0.0884,-0.35356 0.0884,-5.56847 2.74004,-6.71752 2.65165,-1.14905 3.0052,5.12653 3.0052,5.12653",
      "id": "path24240-5",
      "inkscape:connector-curvature": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24242-7",
      "d": "m 843.97254,242.63899 c -3.43821,0.3631 -8.58565,2.8086 -10.20689,7.98333 -1.62124,5.17473 3.75533,7.67447 8.71565,7.97545 4.96032,0.30097 10.23633,-0.73339 10.02228,-5.14851 -0.21406,-4.4151 -4.154,-9.25475 -8.53104,-10.81027 z"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#859cad",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "transform": "matrix(0.99959543,-0.02844252,0.02844252,0.99959543,0,0)",
      "r": "3.125",
      "cy": "275.49167",
      "cx": "836.12555",
      "id": "circle24244-4"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "transform": "matrix(0.99959543,-0.02844252,0.02844252,0.99959543,0,0)",
      "id": "circle24246-1",
      "cx": "844.29706",
      "cy": "265.30396",
      "r": "2.25"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "color": "#000000",
      "clip-rule": "nonzero",
      "display": "inline",
      "overflow": "visible",
      "visibility": "visible",
      "opacity": "1",
      "isolation": "auto",
      "mix-blend-mode": "normal",
      "color-interpolation": "sRGB",
      "color-interpolation-filters": "linearRGB",
      "solid-color": "#000000",
      "solid-opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-dashoffset": "0",
      "stroke-opacity": "1",
      "color-rendering": "auto",
      "image-rendering": "auto",
      "shape-rendering": "auto",
      "text-rendering": "auto",
      "enable-background": "accumulate"
    },
    attrs: {
      "transform": "matrix(0.99959543,-0.02844252,0.02844252,0.99959543,0,0)",
      "r": "2.25",
      "cy": "265.24146",
      "cx": "828.48456",
      "id": "circle24248-8"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24250-5",
      "d": "m 837.06641,254.09868 c 0,0 2.95383,2.72959 6.26321,2.5729 3.30938,-0.15669 6.30487,-2.55536 6.30487,-2.55536"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24252-9",
      "d": "m 826.78146,237.63455 5.11633,-4.77246 -1.12429,-2.15639 2.4383,-0.007 -0.73878,-1.79222 2.38471,0.3073 0.9897,-6.96847 c 0,0 0.24431,1.99386 1.66852,3.70404 1.42422,1.71019 4.34072,3.12781 4.34072,3.12781"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m 859.9813,236.68988 -5.37943,-4.47381 0.99986,-2.21683 -2.43474,0.1318 0.63567,-1.83132 -2.36337,0.4424 -1.38434,-6.90092 c 0,0 -0.13054,2.00452 -1.45521,3.79293 -1.32467,1.7884 -4.15584,3.36956 -4.15584,3.36956",
      "id": "path24254-7",
      "inkscape:connector-curvature": "0"
    }
  })]), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -582.6222,8884.7469 c 0,0 1.4992,-2.2606 2.4349,-4.0016 0.5686,-1.0579 1.4441,-3.2108 1.4441,-3.2108",
      "id": "path24256-5",
      "inkscape:connector-curvature": "0",
      "sodipodi:nodetypes": "csc"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "sodipodi:nodetypes": "csc",
      "inkscape:connector-curvature": "0",
      "id": "path24258-3",
      "d": "m -550.236,8884.7469 c 0,0 -1.4992,-2.2606 -2.4349,-4.0016 -0.5686,-1.0579 -1.4441,-3.2108 -1.4441,-3.2108"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -584.7693,8912.0306 c 0,0 1.6596,-20.405 16.5348,-20.642 12.0465,-0.1919 17.2152,9.0795 18.434,18.8295",
      "id": "path24260-8",
      "inkscape:connector-curvature": "0",
      "sodipodi:nodetypes": "csc"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "2",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -575.848,8886.3049 c 0,0 -1.4143,2.74 -3.624,3.8891 -2.2097,1.149 -8.0433,-0.2652 -8.0433,-0.2652 0,0 5.6568,0.3536 7.0711,1.2374 1.4142,0.8839 1.8561,2.6517 1.8561,2.6517",
      "id": "path24262-8",
      "inkscape:connector-curvature": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "2",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -581.3431,8890.7297 7.9549,0.1767",
      "id": "path24264-3",
      "inkscape:connector-curvature": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "2",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m -548.738,8898.1244 c 0,0 -0.8125,-1.9375 1.1875,-4.9375 2,-3 6.5,-3.5625 6.5,-3.5625 0,0 -3.5,2.375 -3.875,3.8125 -0.375,1.4375 -0.25,2.6875 -0.25,2.6875",
      "id": "path24266-1",
      "inkscape:connector-curvature": "0"
    }
  }), _vm._v(" "), _c('g', {
    staticStyle: {
      "display": "inline",
      "stroke": "#859cad",
      "stroke-opacity": "1"
    },
    attrs: {
      "transform": "translate(-1403.7403,8607.9293)",
      "id": "g24373-8"
    }
  }, [_c('g', {
    staticStyle: {
      "stroke": "#859cad",
      "stroke-opacity": "1"
    },
    attrs: {
      "id": "g24361-9",
      "transform": "translate(0.44194174,-0.88388348)"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24357-6",
      "d": "m 977.7519,172.33729 11.26952,11.26951"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "M 989.02141,172.33728 977.7519,183.6068",
      "id": "path24359-4",
      "inkscape:connector-curvature": "0"
    }
  })]), _vm._v(" "), _c('g', {
    staticStyle: {
      "stroke": "#859cad",
      "stroke-opacity": "1"
    },
    attrs: {
      "transform": "translate(40.441942,-0.88388348)",
      "id": "g24365-3"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "d": "m 977.7519,172.33729 11.26952,11.26951",
      "id": "path24367-3",
      "inkscape:connector-curvature": "0"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24369-3",
      "d": "M 989.02141,172.33728 977.7519,183.6068"
    }
  })])]), _vm._v(" "), _c('path', {
    staticStyle: {
      "display": "inline",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#859cad",
      "stroke-width": "1.5",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "4",
      "stroke-dasharray": "none",
      "stroke-opacity": "1"
    },
    attrs: {
      "inkscape:connector-curvature": "0",
      "id": "path24371-8",
      "d": "m -414.761,8805.1921 29.6985,0"
    }
  })])])], 1)]), _c('h1', [_vm._v("D´oh! we could not find this page")]), _c('p', [_vm._v("But we have this racoon-messing-up-with-servers that we couldn't use in other project")]), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: "home"
      }
    }
  }, [_vm._v("Go to Holidays' index")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-content"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 0.052916666 0.052915319"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 0.03622571,4.1085091e-4 C 0.03590929,-3.4449085e-5 0.03542293,6.5091458e-7 0.03542293,6.5091458e-7 H 0.01766784 c 0,0 -4.9808e-4,-3.509999958e-5 -8.2037e-4,4.2189999542e-4 -3.1642e-4,4.571e-4 -1.2891e-4,9.0829909e-4 -1.2891e-4,9.0829909e-4 l 0.0040139,0.00998 c 0,0 7.031e-5,1.583e-4 2.0509e-4,2.93e-4 1.2891e-4,1.524e-4 2.8127e-4,2.461e-4 2.8127e-4,2.461e-4 l 0.0049222,0.0025 c 0,0 1.6407e-4,7.62e-5 3.8088e-4,8.2e-5 2.2268e-4,0 4.4535e-4,-9.96e-5 4.4535e-4,-9.96e-5 l 0.0048988,-0.00247 c 0,0 1.5821e-4,-8.2e-5 2.9299e-4,-2.344e-4 1.4649e-4,-1.582e-4 1.9923e-4,-3.106e-4 1.9923e-4,-3.106e-4 l 0.0039964,-0.00998 c 0,0 1.9337e-4,-4.6879909e-4 -1.2892e-4,-9.1999909e-4 z",
      "fill": "#304392"
    }
  }), _c('path', {
    attrs: {
      "d": "m 0.01486101,0.00110235 c -5.5081e-4,-1.0549909e-4 -8.5552e-4,2.754e-4 -8.5552e-4,2.754e-4 l -0.01256333,0.012552 c 0,0 -3.8089e-4,3.281e-4 -2.8127e-4,8.79e-4 8.789e-5,5.449e-4 5.391e-4,7.383e-4 5.391e-4,7.383e-4 l 0.009903,0.00422 c 0,0 1.5821e-4,5.86e-5 3.5158e-4,5.86e-5 1.9337e-4,1.76e-5 3.7503e-4,-2.34e-5 3.7503e-4,-2.34e-5 l 0.0052503,-0.00172 c 0,0 1.6408e-4,-5.86e-5 3.2229e-4,-2.109e-4 1.5822e-4,-1.524e-4 2.4611e-4,-3.809e-4 2.4611e-4,-3.809e-4 l 0.001711,-0.00522 c 0,0 4.688e-5,-1.641e-4 3.516e-5,-3.75e-4 0,-2.051e-4 -7.618e-5,-3.516e-4 -7.618e-5,-3.516e-4 l -0.0042132,-0.00988 c 0,0 -1.9337e-4,-4.746e-4 -7.4419e-4,-5.625e-4 z",
      "fill": "#b4d35f"
    }
  }), _c('path', {
    attrs: {
      "d": "M 4.1083724e-4,0.01675965 C -3.4504814e-5,0.01709365 6.5377566e-7,0.01757995 6.5377566e-7,0.01757995 v 0.017755 c 0,0 -3.515858966e-5,5.04e-4 4.2190299434e-4,8.204e-4 4.5706158e-4,3.223e-4 9.0826323e-4,1.348e-4 9.0826323e-4,1.348e-4 l 0.00998504,-0.00401 c 0,0 1.5821e-4,-7.62e-5 2.9299e-4,-2.051e-4 1.5235e-4,-1.172e-4 2.4611e-4,-2.813e-4 2.4611e-4,-2.813e-4 l 0.0024963,-0.00492 c 0,0 7.617e-5,-1.582e-4 8.203e-5,-3.75e-4 0,-2.168e-4 -9.961e-5,-4.453e-4 -9.961e-5,-4.453e-4 l -0.0024728,-0.00489 c 0,0 -8.204e-5,-1.582e-4 -2.344e-4,-2.93e-4 -1.5821e-4,-1.523e-4 -3.1056e-4,-2.051e-4 -3.1056e-4,-2.051e-4 l -0.00997918,-0.00403 c 0,0 -4.6878118e-4,-1.993e-4 -9.1998299e-4,1.172e-4 z m 0.0520933028,0 c 4.6878e-4,3.281e-4 4.1018e-4,8.086e-4 4.1018e-4,8.086e-4 v 0.017755 c 0,0 4.102e-5,5.039e-4 -4.1018e-4,8.204e-4 -4.5706e-4,3.223e-4 -9.1413e-4,1.347e-4 -9.1413e-4,1.347e-4 l -0.009985,-0.00401 c 0,0 -1.5236e-4,-7.62e-5 -2.9299e-4,-2.051e-4 -1.465e-4,-1.172e-4 -2.3439e-4,-2.813e-4 -2.3439e-4,-2.813e-4 l -0.0025021,-0.00492 c 0,0 -7.618e-5,-1.582e-4 -8.204e-5,-3.75e-4 0,-2.168e-4 9.376e-5,-4.454e-4 9.376e-5,-4.454e-4 l 0.0024728,-0.00489 c 0,0 8.204e-5,-1.582e-4 2.3439e-4,-2.93e-4 1.5821e-4,-1.524e-4 3.1057e-4,-2.051e-4 3.1057e-4,-2.051e-4 l 0.0099792,-0.00401 c 0,0 4.6879e-4,-1.992e-4 9.1999e-4,1.172e-4 z",
      "fill": "#a9305e"
    }
  }), _c('path', {
    attrs: {
      "d": "m 0.03622571,0.05250415 c -3.1642e-4,4.512e-4 -8.0278e-4,4.102e-4 -8.0278e-4,4.102e-4 H 0.01766784 c 0,0 -4.9808e-4,3.52e-5 -8.2037e-4,-4.219e-4 -3.1642e-4,-4.571e-4 -1.2891e-4,-9.141e-4 -1.2891e-4,-9.141e-4 l 0.0040139,-0.00997 c 0,0 7.031e-5,-1.582e-4 2.0509e-4,-3.047e-4 1.2891e-4,-1.465e-4 2.8127e-4,-2.344e-4 2.8127e-4,-2.344e-4 l 0.0049222,-0.0025 c 0,0 1.6407e-4,-7.62e-5 3.8088e-4,-8.2e-5 2.2268e-4,0 4.4535e-4,9.37e-5 4.4535e-4,9.37e-5 l 0.0048988,0.00247 c 0,0 1.5821e-4,8.21e-5 2.9299e-4,2.344e-4 1.4649e-4,1.641e-4 1.9923e-4,3.106e-4 1.9923e-4,3.106e-4 l 0.0039964,0.00997 c 0,0 1.9337e-4,4.57e-4 -1.2892e-4,9.199e-4 z",
      "fill": "#304392"
    }
  }), _c('path', {
    attrs: {
      "d": "m 0.01486101,0.05185965 c -5.5081e-4,9.37e-5 -8.6138e-4,-2.755e-4 -8.6138e-4,-2.755e-4 L 0.00144216,0.03902675 c 0,0 -3.7503e-4,-3.282e-4 -2.6955e-4,-8.79e-4 8.789e-5,-5.45e-4 5.3909e-4,-7.325e-4 5.3909e-4,-7.325e-4 l 0.00990301,-0.00422 c 0,0 1.5821e-4,-5.86e-5 3.5158e-4,-7.03e-5 1.9337e-4,0 3.7503e-4,3.51e-5 3.7503e-4,3.51e-5 l 0.0052386,0.00171 c 0,0 1.6408e-4,5.86e-5 3.2229e-4,2.11e-4 1.5822e-4,1.465e-4 2.4611e-4,3.75e-4 2.4611e-4,3.75e-4 l 0.001711,0.00522 c 0,0 4.688e-5,1.641e-4 3.516e-5,3.75e-4 0,2.11e-4 -7.618e-5,3.516e-4 -7.618e-5,3.516e-4 l -0.004219,0.00989 c 0,0 -1.8751e-4,4.688e-4 -7.4419e-4,5.625e-4 z m 0.02325741,-0.050757 c 5.5081e-4,-9.96e-5 8.6138e-4,2.754e-4 8.6138e-4,2.754e-4 l 0.01255748,0.012552 c 0,0 3.7502e-4,3.281e-4 2.8126e-4,8.79e-4 -9.961e-5,5.449e-4 -5.5081e-4,7.383e-4 -5.5081e-4,7.383e-4 l -0.009903,0.00422 c 0,0 -1.5822e-4,5.86e-5 -3.5159e-4,5.86e-5 -1.9923e-4,1.76e-5 -3.7502e-4,-2.34e-5 -3.7502e-4,-2.34e-5 l -0.0052386,-0.00172 c 0,0 -1.758e-4,-5.86e-5 -3.2815e-4,-2.109e-4 -1.5821e-4,-1.524e-4 -2.4611e-4,-3.809e-4 -2.4611e-4,-3.809e-4 l -0.0016993,-0.00522 c 0,0 -5.86e-5,-1.641e-4 -5.86e-5,-3.75e-4 1.758e-5,-2.051e-4 8.204e-5,-3.516e-4 8.204e-5,-3.516e-4 l 0.004219,-0.00989 c 0,0 1.9337e-4,-4.688e-4 7.4419e-4,-5.567e-4 z",
      "fill": "#de5d4a"
    }
  }), _c('path', {
    attrs: {
      "d": "m 0.03811842,0.05185965 c 5.5081e-4,9.37e-5 8.6138e-4,-2.755e-4 8.6138e-4,-2.755e-4 l 0.01255748,-0.012557 c 0,0 3.7502e-4,-3.282e-4 2.8126e-4,-8.79e-4 -9.961e-5,-5.45e-4 -5.5081e-4,-7.325e-4 -5.5081e-4,-7.325e-4 l -0.009903,-0.00422 c 0,0 -1.5822e-4,-5.86e-5 -3.5159e-4,-7.03e-5 -1.9923e-4,0 -3.7502e-4,3.51e-5 -3.7502e-4,3.51e-5 l -0.0052386,0.00171 c 0,0 -1.758e-4,5.86e-5 -3.2815e-4,2.109e-4 -1.5821e-4,1.465e-4 -2.4611e-4,3.751e-4 -2.4611e-4,3.751e-4 l -0.0016993,0.00522 c 0,0 -5.86e-5,1.64e-4 -5.86e-5,3.75e-4 1.758e-5,2.109e-4 8.204e-5,3.516e-4 8.204e-5,3.516e-4 l 0.004219,0.00989 c 0,0 1.9337e-4,4.687e-4 7.4419e-4,5.625e-4 z",
      "fill": "#b4d35f"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("Holidays")]), _c('GoogleBtn')], 1)])
},staticRenderFns: []}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "month"
  }, [_c('div', {
    staticClass: "full-calendar-header"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "full-calendar-body"
  }, [_c('div', {
    staticClass: "weeks"
  }, _vm._l((_vm.weekNames), function(week) {
    return _c('div', {
      staticClass: "week"
    }, [_vm._v(_vm._s(week))])
  }), 0), _c('div', {
    ref: "dates",
    staticClass: "dates"
  }, [_c('div', {
    staticClass: "dates-bg"
  }, _vm._l((_vm.currentDates), function(week) {
    return _c('div', {
      staticClass: "week-row"
    }, _vm._l((week), function(day) {
      return _c('div', {
        staticClass: "day-cell",
        class: {
          "today": day.isToday,
          "not-cur-month": !day.isCurMonth,
          "weekend": day.weekDay > 4,
          "isFutureDate": day.isFutureDate
        },
        attrs: {
          "track-by": "$index"
        }
      }, [_vm._l((day.events), function(event) {
        return _c('div', {
          staticClass: "event-item",
          class: {
            "is-start": _vm.isStart(event.start, day.date),
            "is-end": _vm.isEnd(event.end, day.date),
            "holiday": _vm.isHoliday(event),
            "public": _vm.isPublic(event)
          }
        })
      }), _vm._l((day.newVacations), function(event) {
        return _c('div', {
          staticClass: "event-item new-vacations",
          class: {
            "is-start": _vm.isStart(event.start, day.date),
            "is-end": _vm.isEnd(event.end, day.date),
            "newHoliday": _vm.isNewHoliday(event),
            "newHolidayPublic": _vm.isNewHolidayPublic(event)
          }
        })
      }), _c('div', {
        staticClass: "day-number",
        class: {
          "clickable": day.isFutureDate || day.events.length > 0 || !_vm.isHolidaysCalendar
        },
        on: {
          "click": function($event) {
            return _vm.selectThisDay(day, $event)
          }
        }
      }, [_vm._v(_vm._s(day.monthDay))])], 2)
    }), 0)
  }), 0), _c('BookHolidayPopup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpened()),
      expression: "isOpened()"
    }],
    style: ({
      left: _vm.morePos.left + "px",
      top: _vm.morePos.top + "px"
    }),
    attrs: {
      "startDate": _vm.getStartDate,
      "endDate": _vm.getEndDate,
      "bookedDays": _vm.getBookedDays,
      "isHolidaysCalendar": _vm.isHolidaysCalendar,
      "editing": _vm.getEditingId,
      "boxTop": _vm.boxTop,
      "boxLeft": _vm.boxLeft,
      "workingDays": _vm.workingDays,
      "holidayName": _vm.holidayName,
      "showOnly": _vm.showOnly
    },
    on: {
      "show": function($event) {
        return _vm.changeShow()
      }
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      "error": ((_vm.getMe.remainingDays < 1 && _vm.isHolidaysCalendar && !_vm.editing) || _vm.getApiError)
    },
    attrs: {
      "id": "BookHolidayPopup"
    }
  }, [_c('div', {
    staticClass: "book-holiday-popup"
  }, [_c('div', {
    staticClass: "container",
    class: {
      top: _vm.boxTop,
      left: _vm.boxLeft
    }
  }, [(_vm.isHolidaysCalendar && _vm.bookedDays) ? _c('h3', [_vm._v(" " + _vm._s(_vm.holidaysText.text_title))]) : (_vm.isHolidaysCalendar && _vm.holidayName) ? _c('h3', [_vm._v(_vm._s(_vm.publicBookedText.text_title))]) : (!_vm.isHolidaysCalendar && _vm.holidayName) ? _c('h3', [_vm._v(_vm._s(_vm.publicBookedText.text_title))]) : (!_vm.isHolidaysCalendar) ? _c('h3', [_vm._v(_vm._s(_vm.publicText.text_title))]) : _c('h3', [_vm._v(_vm._s(_vm.holidaysBookedText.text_title))]), (_vm.holidayName) ? _c('p', [_vm._v(_vm._s(_vm.holidayName))]) : _vm._e(), (_vm.isHolidaysCalendar && !_vm.showOnly && !_vm.holidayName) ? _c('div', {
    staticClass: "itemsline"
  }, [_c('div', {
    staticClass: "from-day"
  }, [_c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v("From")]), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.startDate))])]), (!_vm.editing) ? _c('div', {
    staticClass: "count-days half"
  }, [_vm._v(_vm._s(_vm.bookedDays + _vm.holidaysText.text_days + (_vm.getMe.remainingDays - _vm.bookedDays) + _vm.holidaysText.text_remaining))]) : _c('div', {
    staticClass: "count-days half"
  }, [_vm._v(_vm._s(_vm.workingDays + _vm.holidaysText.text_days + (_vm.getMe.remainingDays) + _vm.holidaysText.text_remaining))])]), _c('div', {
    staticClass: "to-day"
  }, [_c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v("To")]), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.end))])]), (!_vm.editing) ? _c('div', {
    staticClass: "add-days half"
  }, [_vm._v(_vm._s(_vm.holidaysText.hint_add_days))]) : _vm._e()])]) : _vm._e(), (_vm.getMe.remainingDays < 1 && _vm.isHolidaysCalendar && !_vm.editing && !_vm.holidayName) ? _c('div', {
    staticClass: "itemsline error"
  }, [_vm._v(_vm._s(_vm.limitDaysText))]) : _vm._e(), (_vm.getApiError) ? _c('div', {
    staticClass: "itemsline error"
  }, [_vm._v(_vm._s(_vm.getApiError))]) : _vm._e(), (!_vm.isHolidaysCalendar || _vm.showOnly || _vm.holidayName) ? _c('div', {
    staticClass: "itemsline public"
  }, [_c('div', {
    staticClass: "from-day"
  }, [_c('div', [_c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.startDate))])])])]) : _vm._e(), (!_vm.isHolidaysCalendar && !_vm.editing) ? _c('div', {
    staticClass: "itemsline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newHolidayName),
      expression: "newHolidayName"
    }],
    staticClass: "name",
    attrs: {
      "type": "text",
      "placeholder": "Enter name",
      "name": "newHolidayName"
    },
    domProps: {
      "value": (_vm.newHolidayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newHolidayName = $event.target.value
      }
    }
  })]) : _vm._e(), (_vm.editing && !_vm.holidayName || _vm.editing && !_vm.isHolidaysCalendar) ? _c('div', {
    staticClass: "itemsline"
  }, [_c('button', {
    staticClass: "remove",
    class: {
      disabled: !_vm.canBeDeleted()
    },
    attrs: {
      "disabled": !_vm.canBeDeleted()
    },
    on: {
      "click": function($event) {
        return _vm.removeBooked()
      }
    }
  }, [_vm._v("Remove")]), _c('button', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.cancelRemoveHolidays()
      }
    }
  }, [_vm._v("Cancel")])]) : _c('div', {
    staticClass: "itemsline"
  }, [(!_vm.showOnly && !_vm.holidayName) ? _c('button', {
    staticClass: "save",
    class: {
      disabled: _vm.getMe.remainingDays < 1 && _vm.isHolidaysCalendar
    },
    attrs: {
      "disabled": _vm.isDisabled()
    },
    on: {
      "click": function($event) {
        return _vm.saveBooked()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _c('button', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.cancelBooked()
      }
    }
  }, [_vm._v("Cancel")])])])])])
},staticRenderFns: []}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Navbar"
    }
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": {
        name: "home"
      }
    }
  }, [_vm._v("Holidays")]), (_vm.admin && _vm.isAdmin) ? _c('span', [_vm._v("admin")]) : _vm._e()], 1), _c('div', {
    staticClass: "userMenu",
    class: {
      opened: _vm.showOptions
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showOptions = !_vm.showOptions
      }
    }
  }, [_c('a', {
    staticClass: "user"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.getMe.picture,
      "referrerpolicy": "no-referrer"
    }
  })]), _c('span', {
    staticClass: "content"
  }, [_vm._v("Hi, " + _vm._s(_vm.getMe.name))]), _c('span', {
    staticClass: "arrow"
  }, [_vm._v(" ")])]), (!_vm.admin && _vm.isAdmin) ? _c('router-link', {
    staticClass: "childrens admin",
    attrs: {
      "to": {
        name: "publicHolidays"
      }
    }
  }, [_c('span', {
    staticClass: "content"
  }, [_vm._v("Admin")])]) : _vm._e(), (_vm.admin && _vm.isAdmin) ? _c('router-link', {
    staticClass: "childrens calendar",
    attrs: {
      "to": {
        name: "home"
      }
    }
  }, [_c('span', {
    staticClass: "content calendar"
  }, [_vm._v("My Calendar")])]) : _vm._e(), _c('a', {
    staticClass: "childrens logout",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout()
      }
    }
  }, [_c('span', {
    staticClass: "content"
  }, [_vm._v("Log out")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin"
  }, [_c('Navbar', {
    attrs: {
      "admin": "admin"
    }
  }), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titleCalendarContainer"
  }, [(_vm.getImportSuccess) ? _c('div', {
    staticClass: "importSuccess"
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeSuccess()
      }
    }
  }, [_vm._v("X")]), _vm._v(_vm._s(_vm.IMPORT_SUCCESS))]) : _vm._e(), _c('div', {
    staticClass: "titleCalendar"
  }, [_c('div', {
    staticClass: "menuCalendar"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "titleYear"
  }, [_c('h2', [_vm._v("My calendar " + _vm._s(_vm.getSelectedYear)), _c('span', {
    ref: "arrow",
    on: {
      "click": function($event) {
        return _vm.showYear()
      }
    }
  }, [_vm._v(" ")])]), _c('ul', {
    ref: "dropdown",
    staticClass: "yearList",
    class: {
      active: _vm.editYear
    }
  }, _vm._l((_vm.yearList), function(year) {
    return _c('li', {
      class: {
        current: year === _vm.getSelectedYear
      },
      on: {
        "click": function($event) {
          return _vm.changeYear(year)
        }
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)]), (_vm.showBookedHolidays) ? _c('div', {
    staticClass: "titleGoogleCalendar"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.kaleidersCalendar
    }
  }, [_vm._v("Google calendar")])]) : _vm._e()]), _c('ul', {
    staticClass: "legend"
  }, [(_vm.showBookedHolidays) ? _c('li', {
    staticClass: "booked"
  }, [_c('span'), _vm._v(_vm._s(_vm.BOOKED_HOLIDAY))]) : _vm._e(), _c('li', {
    staticClass: "public"
  }, [_c('span'), _vm._v(_vm._s(_vm.PUBLIC_HOLIDAY))])])]), (!_vm.showBookedHolidays) ? _c('button', {
    staticClass: "importCalendar",
    on: {
      "click": function($event) {
        return _vm.importCalendar()
      }
    }
  }, [_vm._v("Import calendar")]) : _vm._e(), (_vm.showBookedHolidays) ? _c('div', {
    staticClass: "calendarUserData",
    class: {
      noDays: _vm.getMe.remainingDays < 1,
      hasCarryOverDays: _vm.getMe.hasCarryOverDays
    }
  }, [_c('div', {
    staticClass: "days"
  }, [_vm._v(_vm._s(_vm.getMe.remainingDays))]), _c('div', {
    staticClass: "detail"
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.AVAILABLE_DAYS))]), _vm._l((_vm.allYearsNum), function(year) {
    return _c('span', {
      staticClass: "daysPerYear"
    }, [_vm._v(_vm._s(year.year) + " " + _vm._s(year.info) + " (" + _vm._s(year.num) + ")")])
  })], 2)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "google"
  }, [_c('a', {
    attrs: {
      "href": _vm.loginRoute
    }
  }, [_vm._v("Sign in with Google")])])
},staticRenderFns: []}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Wrapper"
    }
  }, [_c('MenuCalendar', {
    attrs: {
      "showBookedHolidays": _vm.isHolidaysCalendar
    }
  }), _c('Calendar')], 1)
},staticRenderFns: []}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-full-calendar"
  }, _vm._l((_vm.totalMonths), function(n) {
    return _c('Month', {
      key: n,
      attrs: {
        "current-date": _vm.setMonth(n),
        "events": _vm.events,
        "isHolidaysCalendar": _vm.isHolidaysCalendar
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "OnHolidaysPopup"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h3', [_vm._v("On holidays")]), _c('span', [_vm._v(_vm._s(_vm.date1))])]), _c('div', {
    staticClass: "lines"
  }, _vm._l((_vm.kaleidersList), function(kaleider, index) {
    return _c('div', {
      staticClass: "line"
    }, [_c('img', {
      attrs: {
        "src": kaleider['picture']
      }
    }), _c('div', [_vm._v(_vm._s(kaleider['name']))])])
  }), 0)])])
},staticRenderFns: []}

/***/ })
]),[78]);


// WEBPACK FOOTER //
// static/js/app.dac03a67339027645c9d.js